var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20201107 at Thu Nov  7 18:13:27 2024\n By \nCopyright 2024 The Parkinsans Project Authors (https://github.com/redstonedesign/parkinsans)\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Parkinsans-Regular",
    horizAdvX: 677
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Parkinsans",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 800,
    descent: -200,
    xHeight: 549,
    capHeight: 693,
    bbox: "-53 -272.5 1081 975",
    underlineThickness: 50,
    underlinePosition: -150,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 600,
    d: "M97 660h413v-660h-413v660zM137 620v-580h333v580h-333zM239 216l-3 103h30q34 0 63.5 10.5t48 33.5t18.5 61q0 42 -27.5 66.5t-71.5 24.5q-38 0 -62.5 -19.5t-31.5 -55.5l-41 12q9 44 44 73t93 29q62 0 101.5 -36t39.5 -91q0 -68 -45.5 -104t-115.5 -36l-3 -71h-37z M262 98q-16 0 -26.5 10.5t-10.5 24.5t10.5 24t26.5 10t26.5 -10t10.5 -24t-10.5 -24.5t-26.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 593,
    d: "M122 0v473h-70v76h70v38q0 47 12 80t36.5 55t62.5 32.5t90 10.5v-78q-39 0 -63 -10t-34.5 -32t-10.5 -58v-38h263v-76h-263v-473h-93zM424 0v549h92v-549h-92zM470 637q-29 0 -50 19t-21 47q0 29 20.5 48t50.5 19q29 0 50 -19t21 -48q0 -28 -21 -47t-50 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 602,
    d: "M94 0v473h-71v76h71v38q0 47 11.5 80t36 55t62.5 32.5t91 10.5v-78q-40 0 -64 -10t-34.5 -31.5t-10.5 -58.5v-38h115v-76h-115v-473h-92zM522 -7q-28 0 -55 12t-44.5 38t-17.5 68v629h92v-621q0 -23 13 -34.5t31 -11.5q11 0 21 4l20 -69q-25 -15 -60 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 600,
    d: "M97 660h413v-660h-413v660zM137 620v-580h333v580h-333zM239 216l-3 103h30q34 0 63.5 10.5t48 33.5t18.5 61q0 42 -27.5 66.5t-71.5 24.5q-38 0 -62.5 -19.5t-31.5 -55.5l-41 12q9 44 44 73t93 29q62 0 101.5 -36t39.5 -91q0 -68 -45.5 -104t-115.5 -36l-3 -71h-37z M262 98q-16 0 -26.5 10.5t-10.5 24.5t10.5 24t26.5 10t26.5 -10t10.5 -24t-10.5 -24.5t-26.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 267
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 306,
    d: "M104 693h99l-11 -495h-78zM154 -6q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 294,
    d: "M36 796h86l-11 -199h-64zM171 796h86l-10 -199h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 842,
    d: "M305 740h88l-158 -740h-88zM602 740h88l-158 -740h-88zM33 281h697v-81h-697v81zM90 541h697v-81h-697v81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 636,
    d: "M283 -87v875h54v-875h-54zM308 -7q-68 0 -121.5 25.5t-86 71t-40.5 106.5l96 18q11 -66 50.5 -103t101.5 -37q67 0 103.5 30t36.5 79q0 40 -20.5 63.5t-54 37.5t-73.5 24t-80.5 22t-74 32.5t-54 55.5t-20.5 90q0 58 29 101t81.5 67t121.5 24q63 0 111.5 -25.5t78.5 -65.5 t36 -86l-93 -24q-10 55 -47.5 88t-90.5 33q-37 0 -67 -12t-48 -35.5t-18 -61.5t20.5 -61t54 -36.5t73.5 -24t80 -23t73.5 -33.5t54 -55.5t20.5 -89.5q0 -50 -26.5 -94.5t-78.5 -72.5t-128 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 760,
    d: "M132 0l405 693h91l-405 -693h-91zM189 400q-63 0 -104.5 40t-41.5 110t41.5 110t104.5 40t104.5 -40t41.5 -110t-41.5 -110t-104.5 -40zM188 457q34 0 54 23.5t20 69.5q0 47 -20 70t-53 23t-53 -23t-20 -70q0 -46 20 -69.5t52 -23.5zM572 -7q-62 0 -104 40t-42 111 q0 70 41.5 110t104.5 40t104.5 -40t41.5 -110q0 -71 -42 -111t-104 -40zM572 51q33 0 53 23t20 70t-20 69.5t-53 22.5t-53.5 -22.5t-20.5 -69.5t20.5 -70t53.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 740,
    d: "M612 0l-383 387q-48 48 -68 86t-20 83t22.5 80t64 55t97.5 20t94.5 -22.5t60 -60t24.5 -84.5l-85 -19q-2 48 -31.5 79t-66.5 31q-40 0 -64 -22.5t-24 -56.5q0 -31 17 -60t55 -67l427 -429h-120zM281 -12q-72 0 -127 26t-86 74t-31 112q0 78 48 137t143 90l35 11l50 -61 l-43 -14q-72 -25 -106.5 -65t-34.5 -95q0 -38 19.5 -69t53.5 -49t79 -18q52 0 94.5 19t80 59.5t73.5 102.5l62 107l79 -37l-56 -98q-45 -78 -94.5 -130t-107.5 -77t-131 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 160,
    d: "M36 796h88l-12 -199h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 456,
    d: "M312 -186q-64 63 -109 149t-69.5 188.5t-24.5 215.5q0 112 25 217.5t73.5 195t119.5 154.5h101q-76 -72 -127.5 -166t-77 -197t-25.5 -204q0 -102 25 -201.5t73.5 -189.5t117.5 -162h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 456,
    d: "M145 -186h-103q70 72 118 162t73 189.5t25 201.5q0 101 -25.5 204t-76.5 197t-128 166h101q72 -65 120.5 -154.5t73 -195t24.5 -217.5q0 -113 -24 -215.5t-69 -188.5t-109 -149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 487,
    d: "M265 589l122 88l37 -66l-139 -57l139 -58l-37 -67l-122 88l17 -151h-75l15 151l-122 -89l-39 69l139 57l-138 56l37 67l124 -88l-16 151h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 625,
    d: "M355 621v-510h-85v510h85zM58 405h510v-78h-510v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 196,
    d: "M9 -104v48q27 -1 49 6.5t36.5 22.5t18.5 33q-7 -5 -16.5 -8.5t-19.5 -3.5q-26 0 -45.5 14.5t-19.5 46.5t22 51t53 19q25 0 43 -13.5t28.5 -34.5t10.5 -45q0 -47 -23 -78.5t-59.5 -46t-77.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 552,
    d: "M95 405h400v-77h-400v77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 230,
    d: "M116 -7q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 478,
    d: "M327 942h92l-274 -1112h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 629,
    d: "M314 -7q-87 0 -143 50t-82 134.5t-26 189.5q0 103 26 186.5t82 132.5t143 49q88 0 143.5 -49t82 -132.5t26.5 -186.5q0 -105 -26.5 -189.5t-82 -134.5t-143.5 -50zM314 77q59 0 94.5 40t51 106t15.5 144q0 56 -8.5 107t-27.5 91t-50 63t-75 23t-74.5 -23t-49.5 -63 t-28 -91t-9 -107q0 -78 16 -144t51.5 -106t93.5 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 415,
    d: "M16 0v77h152v532q-14 -26 -40 -45t-55 -29.5t-57 -10.5v87q35 0 68.5 15.5t58 41.5t32.5 56h85v-647h139v-77h-383z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 574,
    d: "M51 0v67q31 24 57.5 46t50 42t45.5 40t45 42q30 28 60.5 61t55.5 69t40 74t15 75q0 63 -32 102t-102 39q-42 0 -73 -19.5t-49.5 -54.5t-24.5 -84l-84 13q5 67 36 117t82 78t114 28q70 0 120 -26.5t77 -74.5t27 -114q0 -52 -20 -101.5t-53.5 -96.5t-75.5 -90.5t-87 -82.5 t-86 -72h343v-77h-481z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 589,
    d: "M294 -7q-65 0 -117.5 24.5t-86 69t-41.5 105.5l85 14q6 -41 27.5 -71.5t55 -47t76.5 -16.5q52 0 83.5 18t46.5 48.5t15 67.5q0 73 -51 105t-149 32h-24v77h25q91 0 138 29.5t47 90.5q0 53 -34 85.5t-98 32.5q-40 0 -71.5 -15.5t-51.5 -45t-25 -71.5l-84 17 q11 89 73.5 141t161.5 52q70 0 118.5 -24.5t74 -66.5t25.5 -96q0 -60 -34.5 -106.5t-93.5 -59.5v0q64 -15 103 -62t39 -122q0 -55 -27 -102t-79 -75t-127 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 630,
    d: "M410 0v166h-370v69l350 489h111v-479h100v-79h-100v-166h-91zM146 245h268v382z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 624,
    d: "M324 -7q-75 0 -127 26.5t-82 70.5t-40 95l83 20q8 -38 29 -68.5t56 -48t83 -17.5q46 0 80 23.5t53 63t19 86.5q0 46 -18.5 83.5t-52.5 60t-81 22.5q-56 0 -96 -30t-59 -75l-87 23v396h436v-81h-351v-256q11 20 35 43.5t60 39.5t84 16q60 0 109.5 -29.5t79 -83.5 t29.5 -129q0 -69 -30 -126t-84.5 -91t-127.5 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 636,
    d: "M334 -7q-88 0 -146 45t-86.5 123t-28.5 178q0 88 17.5 161t51 125.5t81.5 81t109 28.5t108 -25.5t76 -66.5t36 -90l-81 -18q-12 56 -48 89t-91 33q-39 0 -71 -18.5t-56.5 -56t-38 -96t-13.5 -138.5q14 37 43.5 65.5t68.5 45t82 16.5q67 0 118 -29.5t80 -83.5t29 -128 q0 -66 -29 -120.5t-82.5 -87.5t-128.5 -33zM333 71q45 0 80 21.5t55 58.5t20 84q0 46 -18.5 83t-53.5 58t-83 21q-39 0 -77 -19t-62 -54t-24 -86q0 -42 19 -80t55.5 -62.5t88.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 547,
    d: "M136 0l282 646h-385v78h475v-69l-279 -655h-93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 631,
    d: "M316 -7q-79 0 -136.5 26.5t-88.5 74.5t-31 112q0 67 36 113.5t98 64.5q-57 23 -86.5 63.5t-29.5 98.5q0 59 30 101.5t83.5 65t124.5 22.5q68 0 121.5 -21.5t84.5 -63.5t31 -104q0 -58 -30.5 -100t-84.5 -62q62 -19 98 -65t36 -113q0 -64 -31 -112t-88.5 -74.5 t-136.5 -26.5zM316 70q77 0 121.5 37.5t44.5 101.5q0 67 -46 100.5t-120 33.5t-121 -33.5t-47 -100.5q0 -64 45 -101.5t123 -37.5zM316 413q66 0 107.5 33t41.5 89q0 61 -39.5 92t-109.5 31q-69 0 -109 -30.5t-40 -92.5q0 -56 41.5 -89t107.5 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 640,
    d: "M313 735q89 0 147 -46t86 -125t28 -179q0 -118 -31 -206t-89.5 -137t-140.5 -49q-62 0 -110.5 25.5t-79 66.5t-38.5 90l82 18q11 -56 50.5 -89t96.5 -33q38 0 71 18t57.5 55t38 95t13.5 138q-14 -38 -43 -66.5t-66 -45t-77 -16.5q-67 -1 -120 29.5t-84 85t-31 127.5 q0 67 29 122t83 88.5t128 33.5zM314 657q-44 0 -79.5 -22t-55.5 -60t-20 -86q0 -45 19 -82t54 -59t83 -22q40 0 77 19t61.5 55t24.5 86q0 31 -11 61.5t-32 55.5t-51 39.5t-70 14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 233,
    d: "M116 -7q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5zM116 421q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 252,
    d: "M123 421q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5zM45 -104v48q27 -1 48.5 6.5t36.5 22.5t19 33q-8 -5 -17.5 -8.5t-18.5 -3.5q-27 0 -46 14.5t-19 46.5t22 51t53 19q24 0 42 -13.5t28.5 -34.5 t10.5 -45q0 -47 -23 -78.5t-59 -46t-77 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 625,
    d: "M491 136h-116l-241 230l241 229h116l-241 -229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 625,
    d: "M52 297h521v-77h-521v77zM52 513h521v-78h-521v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 625,
    d: "M376 366l-242 229h117l240 -229l-240 -230h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 522,
    d: "M150 194l-5 159h55q50 0 92.5 14.5t68 46.5t25.5 83q0 57 -36.5 91.5t-97.5 34.5q-53 0 -87.5 -30t-44.5 -83l-83 23q9 47 36 85t72 60.5t107 22.5q66 0 115.5 -25t78 -70.5t28.5 -106.5q0 -67 -31.5 -114t-86 -71.5t-123.5 -24.5l-4 -95h-79zM198 -7q-30 0 -50.5 19.5 t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1014,
    d: "M615 120l2 34l19 -31q-26 -58 -81 -93.5t-119 -35.5q-77 0 -119.5 46.5t-42.5 125.5q0 56 17.5 107t50 90.5t77.5 63t100 23.5q61 0 97 -30.5t45 -90.5l-25 -13l22 123h80l-51 -288q-6 -42 3.5 -68.5t46.5 -26.5q33 0 57 23.5t40 61t24 80.5t8 82q0 87 -35 148t-102 93 t-163 32q-90 0 -166.5 -33t-132.5 -92.5t-87 -138.5t-31 -171q0 -88 36 -149.5t103.5 -93t161.5 -31.5q41 0 84.5 8t80.5 26l13 -62q-45 -19 -95 -28.5t-102 -9.5q-108 0 -188.5 41t-125 115.5t-44.5 175.5q0 107 37 199.5t105 162t160 108t203 38.5q113 0 194.5 -42 t125 -117t43.5 -175q0 -57 -14 -113t-42 -101t-68.5 -72t-92.5 -27q-61 0 -87.5 35t-21.5 91zM519 379q-50 0 -85.5 -29.5t-55 -75t-19.5 -95.5t26 -82t79 -32q44 0 80 24.5t58 66t25 92.5q3 36 -8.5 66t-36 47.5t-63.5 17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 675,
    d: "M391 693l251 -693h-97l-229 642h44l-230 -642h-97l252 693h106zM157 230h356l25 -76h-405z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 614,
    d: "M78 0v693h250q74 0 123 -24t73.5 -63.5t24.5 -88.5q0 -52 -22.5 -87t-58.5 -54.5t-78 -26.5l15 11q44 -1 80 -25t58 -63t22 -86q0 -52 -27 -94.5t-77.5 -67t-122.5 -24.5h-260zM170 76h160q67 0 105 31.5t38 88.5t-40 90t-106 33h-157v-243zM170 395h152q63 0 98 29 t35 82q0 52 -34.5 81.5t-100.5 29.5h-150v-222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 766,
    d: "M391 -7q-73 0 -136 26t-111 73.5t-74.5 112t-26.5 142.5q0 77 26.5 141.5t74.5 112t111 73.5t136 26q76 0 139.5 -25.5t110 -75t68.5 -121.5l-87 -27q-28 79 -86 123.5t-143 44.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144t33 -144.5t91 -95t130 -33.5q79 0 141.5 42 t93.5 116l88 -20q-24 -70 -72 -118.5t-112.5 -74.5t-138.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 708,
    d: "M78 0v693h217q114 0 196.5 -42.5t127.5 -120.5t45 -185q0 -108 -45 -185t-127.5 -118.5t-196.5 -41.5h-217zM170 76h125q136 0 205.5 71t69.5 198q0 125 -69.5 198.5t-205.5 73.5h-125v-541z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 504,
    d: "M78 693h393v-76h-301v-230h245v-76h-245v-311h-92v693z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 775,
    d: "M612 465q-10 29 -29.5 56t-48 49t-64 35.5t-78.5 13.5q-73 0 -130.5 -34t-91 -95t-33.5 -143t32 -143.5t90.5 -95.5t134.5 -34q52 0 93.5 21.5t72 56t48 75t20.5 77.5h-262v76h366v-380h-85v221l11 3q-3 -19 -14.5 -48t-32.5 -61t-52.5 -59.5t-73.5 -45t-96 -17.5 q-72 0 -134.5 26t-110 73.5t-74.5 112t-27 142.5q0 77 26 142t73.5 112t111.5 73t139 26q109 0 191 -53t119 -149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 692,
    d: "M78 693h92v-693h-92v693zM523 693h92v-693h-92v693zM152 389h394v-75h-394v75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 368,
    d: "M63 0v76h75v541h-75v76h242v-76h-75v-541h75v-76h-242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 531,
    d: "M238 -7q-48 0 -83.5 17t-60 43.5t-37.5 57.5t-16 58l88 26q10 -57 38.5 -88.5t69.5 -31.5q35 0 56.5 14.5t32 39t10.5 53.5v511h92v-511q0 -58 -24 -100.5t-67 -65.5t-99 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 606,
    d: "M78 0v693h92v-299q92 3 154 41t96.5 104.5t42.5 153.5h98q-4 -56 -24.5 -110.5t-53.5 -101t-74 -79.5t-86 -45q70 -17 126.5 -65t92.5 -122t43 -170h-98q-6 104 -47 173t-110 105t-160 38v-316h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 433,
    d: "M170 693v-618h243v-75h-335v693h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 862,
    d: "M78 693h98l273 -610h-34l272 610h98v-693h-92v597l36 -3l-265 -594h-65l-266 594l37 3v-597h-92v693z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 704,
    d: "M627 693v-693h-92l-365 549v-549h-92v693h92l365 -548v548h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 786,
    d: "M393 -7q-73 0 -137 26t-112 73t-74.5 111.5t-26.5 143.5q0 77 26.5 141.5t74.5 112t112 73.5t137 26q74 0 138 -26t111.5 -73.5t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94t33.5 146q0 83 -33.5 144t-91 94.5 t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 580,
    d: "M78 0v693h225q82 0 135.5 -27.5t79.5 -73.5t26 -103q0 -53 -24.5 -99.5t-77 -75t-139.5 -28.5h-133v-286h-92zM170 362h133q78 0 112.5 34.5t34.5 92.5q0 61 -34.5 94.5t-112.5 33.5h-133v-255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 777,
    d: "M673 -118q-33 0 -69.5 13.5t-67.5 42.5t-48 77l76 39q17 -45 47 -65.5t69 -20.5q11 0 23 1.5t24 4.5v-83q-11 -4 -24.5 -6.5t-29.5 -2.5zM393 -7q-73 0 -136.5 26t-112 73t-75 111.5t-26.5 143.5q0 77 26.5 141.5t75 112t112 73.5t136.5 26q74 0 138 -26t111.5 -73.5 t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94t33.5 146q0 83 -33.5 144t-91 94.5t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 647,
    d: "M78 0v693h225q81 0 135 -27.5t80.5 -73t26.5 -102.5q0 -72 -44.5 -120t-114.5 -63q54 -17 97 -58t71 -103t37 -146h-98q-7 85 -39 144.5t-91 92.5q-37 21 -85.5 31t-107.5 10v-278h-92zM170 355h133q74 0 110.5 38.5t36.5 94.5q0 59 -36 94t-111 35h-133v-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 595,
    d: "M305 -7q-68 0 -121.5 25.5t-86 71t-40.5 106.5l96 18q11 -66 50.5 -103t101.5 -37q67 0 103.5 30t36.5 79q0 40 -20.5 63.5t-54 37.5t-73.5 24t-80.5 22t-74 32.5t-54 55.5t-20.5 90q0 58 29 101t81.5 67t121.5 24q63 0 111.5 -25.5t78.5 -65.5t36 -86l-93 -24 q-10 55 -47.5 88t-90.5 33q-37 0 -67 -12t-48 -35.5t-18 -61.5t20.5 -61t54 -36.5t73.5 -24t80 -23t73.5 -33.5t54 -55.5t20.5 -89.5q0 -50 -26.5 -94.5t-78.5 -72.5t-128 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 542,
    d: "M35 693h472v-76h-190v-617h-92v617h-190v76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    d: "M557 693h97l-263 -693h-106l-263 693h99l217 -596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 977,
    d: "M23 693h98l165 -638h-28l182 638h103l175 -639h-29l167 639h98l-202 -693h-103l-174 602h26l-181 -602h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 623,
    d: "M46 693h103l428 -693h-103zM327 302l-178 -302h-103l230 372zM298 390l178 303h102l-229 -373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 585,
    d: "M19 693h103l192 -391h-41l191 391h102l-227 -431v-262h-92v262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 542,
    d: "M493 620l-338 -539h340v-81h-448v73l337 539h-334v81h443v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 426,
    d: "M134 934h181v-76h-95v-967h95v-77h-181v1120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 661,
    d: "M537 -170h-91l-313 1112h91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 426,
    d: "M292 934v-1120h-181v77h95v967h-95v76h181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 630,
    d: "M316 580l-184 -410h-95l236 523h85l236 -523h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 736,
    d: "M106 -37h534v-86h-534v86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 257,
    d: "M17 783l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 678,
    d: "M377 -7q-70 0 -126 35t-81 94v-68q0 -24 -14.5 -39t-39.5 -15h-38v740h92v-312q25 59 80 93.5t127 34.5q71 0 129.5 -35t93 -98.5t34.5 -147.5t-34.5 -147.5t-93 -99t-129.5 -35.5zM355 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24 q-49 0 -91.5 -24t-68 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t68 -69.5t91.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 607,
    d: "M310 -7q-78 0 -138.5 34.5t-94.5 98t-34 149.5t34 149t94.5 97.5t138.5 34.5q46 0 85 -10t70 -31t53.5 -52.5t36.5 -73.5l-87 -28q-19 57 -58.5 87t-99.5 30q-49 0 -88.5 -23t-62 -68t-22.5 -112t22.5 -112.5t62 -68.5t88.5 -23q69 0 111 36.5t57 95.5l85 -21 q-14 -54 -47.5 -97t-84.5 -67.5t-121 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v312h92v-740h-38q-25 0 -39.5 15t-14.5 39v68q-24 -59 -80 -94t-127 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 623,
    d: "M334 -7q-64 0 -117.5 20t-92.5 56.5t-60 87.5t-21 114q0 62 23.5 114t64 90.5t93 59.5t109.5 21q51 0 93 -13.5t72.5 -37.5t47 -55t16.5 -68q0 -52 -29 -86.5t-77 -54t-105.5 -27t-115.5 -5.5q-16 0 -35 1t-35 2.5t-25 2.5q6 -39 32 -72t68 -52t94 -19q40 0 76.5 14 t65 36t46.5 45l68 -50q-26 -36 -65 -64t-87 -44t-104 -16zM237 285q40 0 81 4.5t76 15t56.5 29.5t21.5 47t-17.5 49.5t-48 34t-68.5 12.5q-57 0 -102.5 -26.5t-72 -69.5t-29.5 -91q18 -2 44.5 -3.5t58.5 -1.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 329,
    d: "M94 0v473h-71v76h71v38q0 47 11.5 80t36 55t62.5 32.5t91 10.5v-78q-40 0 -64 -10t-34.5 -31.5t-10.5 -58.5v-38h115v-76h-115v-473h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    d: "M333 -267q-69 0 -123.5 22.5t-93.5 63.5t-61 94l83 37q28 -62 78.5 -99t116.5 -37q51 0 90 21t61.5 60.5t22.5 95.5v131q-24 -59 -80 -94t-127 -35q-73 0 -131.5 35.5t-92 99t-33.5 147.5t33.5 147.5t92 98.5t131.5 35t128 -34.5t79 -93.5v121h92v-557 q0 -56 -18.5 -103.5t-53 -82t-84 -54t-110.5 -19.5zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 641,
    d: "M78 0v740h92v-308q12 34 39.5 62t65.5 45t81 17q65 0 113 -29t74 -81t26 -123v-323h-91v300q0 83 -42 129.5t-110 46.5q-44 0 -79.5 -24.5t-56 -67.5t-20.5 -99v-285h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 256,
    d: "M82 0v549h92v-549h-92zM128 637q-29 0 -50 19t-21 47q0 29 20.5 48t50.5 19q29 0 50 -19t21 -48q0 -28 -21 -47t-50 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 263,
    d: "M39 -267q-23 0 -45.5 7.5t-44.5 22.5l34 70q21 -10 40 -10q28 0 45.5 22t17.5 61v643h92v-660q0 -50 -19.5 -85t-51 -53t-68.5 -18zM130 637q-29 0 -50 19t-21 47q0 29 20.5 48t50.5 19q29 0 50 -19t21 -48q0 -28 -21 -47t-50 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 548,
    d: "M78 0v740h92v-426q61 11 113 42t88.5 79.5t50.5 113.5h99q-15 -69 -52.5 -124t-86 -92.5t-98.5 -55.5q36 -9 76.5 -34.5t78.5 -62.5t65 -83t36 -97h-99q-10 45 -36.5 85t-64 72t-81.5 52t-89 24v-233h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 281,
    d: "M78 111v629h92v-621q0 -23 13 -34.5t31 -11.5q11 0 21 4l20 -69q-25 -15 -60 -15q-28 0 -55 12t-44.5 38t-17.5 68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1031,
    d: "M78 0v549h92v-117q12 34 38.5 62t63 45t77.5 17q76 0 129.5 -39.5t69.5 -106.5q12 42 40 74.5t68.5 52t87.5 19.5q97 0 155.5 -60.5t58.5 -171.5v-324h-91v303q0 82 -41 127.5t-108 45.5q-68 0 -111 -52.5t-43 -139.5v-284h-91v299q0 83 -41 130t-108 47 q-45 0 -79.5 -24.5t-54.5 -68t-20 -99.5v-284h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 641,
    d: "M78 0v549h92v-117q12 34 39.5 62t65.5 45t81 17q65 0 113 -29t74 -81t26 -123v-323h-91v300q0 83 -42 129.5t-110 46.5q-44 0 -79.5 -24.5t-56 -67.5t-20.5 -99v-285h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 640,
    d: "M317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22t-67 -66.5t-25.5 -112.5t25 -113 t66 -67t89 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 678,
    d: "M377 -7q-70 0 -126 35t-81 94v-382h-92v809h92v-121q25 59 80 93.5t127 34.5q71 0 129.5 -35t93 -98.5t34.5 -147.5t-34.5 -147.5t-93 -99t-129.5 -35.5zM355 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24q-49 0 -91.5 -24t-68 -68.5 t-25.5 -108.5q0 -63 25.5 -108.5t68 -69.5t91.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M507 -260v382q-24 -59 -80 -94t-127 -35t-129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-809h-92zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24t-67.5 -68.5t-25.5 -108.5 q0 -63 25.5 -108.5t67.5 -69.5t92 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 375,
    d: "M78 0v549h92v-549h-92zM137 281l33 146q19 61 66 95t112 34v-96q-8 2 -15.5 2.5t-14.5 0.5q-43 0 -76.5 -22.5t-52.5 -63t-19 -96.5h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 516,
    d: "M266 -7q-60 0 -106 20.5t-74.5 55t-38.5 76.5l86 19q10 -41 44 -67t87 -26q55 0 83.5 22.5t28.5 56.5q0 30 -23.5 47t-60.5 28t-78.5 22t-78.5 28.5t-60 47.5t-23 80q0 43 25 77.5t70.5 55t106.5 20.5q57 0 98 -18.5t66.5 -50.5t34.5 -73l-85 -23q-9 37 -37 62t-80 25 q-51 0 -78.5 -21t-27.5 -53t23 -50t59.5 -29.5t78 -22.5t78 -27.5t59.5 -46t23 -78.5q0 -43 -24.5 -79t-69.5 -57t-106 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 387,
    d: "M253 -7q-57 0 -95.5 38.5t-38.5 101.5v340h-93v76h311v-76h-125v-344q0 -26 14.5 -40t34.5 -14q15 0 27.5 5.5t23.5 14.5l45 -63q-21 -19 -47 -29t-57 -10zM75 509v40q21 0 32.5 11.5t11.5 33.5v92h93v-76q0 -14 -5.5 -27t-16.5 -22t-26 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 641,
    d: "M472 54v495h92v-549h-38q-24 0 -39 15t-15 39zM288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5l20 -32q-1 -81 -29.5 -133.5t-74 -78.5t-100.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 562,
    d: "M111 549l170 -464l170 464h98l-215 -549h-107l-214 549h98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 820,
    d: "M13 549h93l142 -518h-33l152 518h94l148 -518h-32l140 518h91l-171 -549h-95l-151 499h39l-150 -499h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 480,
    d: "M14 549h104l349 -549h-104zM252 234l-143 -234h-96l199 306zM228 316l142 233h96l-198 -306z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 615,
    d: "M458 -9v558h92v-558q0 -56 -17 -103t-50 -81.5t-80.5 -54t-109.5 -19.5t-113 21t-87.5 62t-57.5 102l85 31q23 -66 69 -101t103 -35q77 0 121.5 47.5t44.5 130.5zM484 260q-1 -76 -20.5 -126t-50 -78.5t-66.5 -40t-72 -11.5q-65 0 -114 28.5t-75.5 80.5t-26.5 124v312h92 v-290q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55 67t19.5 98.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 456,
    d: "M412 473l-265 -397h268v-76h-374v76l266 397h-264v76h369v-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 465,
    d: "M106 338v72q56 9 79 37.5t23 66.5q0 39 -4.5 86t-9.5 95.5t-5 91.5q0 73 41 110.5t107 37.5h58v-80h-41q-37 0 -56.5 -17.5t-19.5 -57.5q0 -38 5 -84.5t9.5 -94.5t4.5 -90q0 -50 -25.5 -87t-82.5 -49v-2q57 -12 82.5 -48.5t25.5 -88.5q0 -41 -4.5 -89t-9.5 -94.5 t-5 -84.5q0 -40 19.5 -57.5t56.5 -17.5h41v-80h-58q-66 0 -107 37.5t-41 110.5q0 43 5 91t9.5 95.5t4.5 85.5t-23 66.5t-79 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 293,
    d: "M193 796v-902h-92v902h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 465,
    d: "M359 338q-56 -10 -79 -38.5t-23 -66.5t5 -85.5t9.5 -95.5t4.5 -91q0 -73 -41 -110.5t-107 -37.5h-58v80h41q37 0 56.5 17.5t19.5 57.5q0 38 -5 84.5t-9.5 94.5t-4.5 89q0 52 25.5 88.5t82.5 48.5v2q-57 12 -82.5 49t-25.5 87q0 42 4.5 90t9.5 94.5t5 84.5 q0 40 -19.5 57.5t-56.5 17.5h-41v80h58q66 0 107 -37.5t41 -110.5q0 -43 -4.5 -91.5t-9.5 -95.5t-5 -86q0 -38 23 -66.5t79 -37.5v-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 520,
    d: "M341 246q-28 0 -50 10t-40.5 23t-37 23t-40.5 10q-26 0 -44.5 -17t-23.5 -47h-68q13 76 50 111.5t92 35.5q29 0 51 -10t41 -23t37.5 -23t39.5 -10q26 0 44.5 17t22.5 47h68q-12 -75 -49 -111t-93 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 267
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 306,
    d: "M104 -134l10 495h78l11 -495h-99zM154 564q29 0 49.5 -19t20.5 -47q0 -27 -20.5 -46t-49.5 -19q-30 0 -50.5 19t-20.5 46q0 28 20.5 47t50.5 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 665,
    d: "M321 1q-82 0 -139 34.5t-87 93t-30 133.5q0 76 31.5 135t88.5 93t133 34q65 0 111.5 -20t76.5 -56.5t45 -86.5l-84 -24q-16 52 -54 82t-96 30q-48 0 -87 -22t-61 -64t-22 -102q0 -59 22.5 -100.5t62 -63.5t89.5 -22q46 0 75.5 15.5t47.5 42.5t28 62l80 -18 q-12 -49 -41 -89t-75.5 -63.5t-114.5 -23.5zM293 -89v145h54v-145h-54zM293 466v145h54v-145h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 621,
    d: "M94 0l-12 61q45 43 64.5 83.5t20 80.5t-13.5 83h-109v68h88q-9 29 -17 60t-8 74q0 64 28.5 111.5t79 73.5t115.5 26t112.5 -26.5t73.5 -71t27 -100.5l-84 -11q-1 39 -17 68t-44 46t-69 17q-36 0 -66 -14t-48 -44.5t-18 -79.5q0 -35 8.5 -66.5t19.5 -62.5h193v-68h-173 q17 -68 -3 -126t-78 -105h382v-77h-452z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 537,
    d: "M267 201q-51 0 -90.5 21.5t-62 61.5t-22.5 93q0 54 23 93.5t63 61.5t91 22q50 0 90.5 -22t63.5 -61.5t23 -93.5q0 -53 -23.5 -93t-64 -61.5t-91.5 -21.5zM105 170l-42 42l84 84l45 -39zM432 170l-81 81l42 42l81 -81zM267 259q39 0 70.5 30.5t31.5 87.5q0 58 -30.5 88.5 t-70.5 30.5q-41 0 -70 -30.5t-29 -88.5q0 -57 29 -87.5t69 -30.5zM147 462l-84 82l42 42l84 -84zM388 458l-40 43l84 85l42 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 595,
    d: "M355 384h190v-69h-203zM53 224h492v-68h-492v68zM25 693h103l192 -391h-43l192 391h103l-227 -431v-262h-92v262zM53 384h204l12 -69h-216v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 293,
    d: "M193 273v-379h-92v379h92zM101 417v379h92v-379h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 575,
    d: "M295 -197q-60 0 -107 19.5t-74.5 56.5t-29.5 90h92q3 -28 15.5 -50.5t38.5 -36.5t65 -14q52 0 82 21.5t30 63.5q0 26 -14 44t-48.5 35.5t-97.5 37.5q-62 20 -107.5 44.5t-69.5 59t-24 83.5q0 44 22 81t66 62t109 31l-8 -32q-41 16 -77.5 35.5t-59 48.5t-22.5 71 q0 43 24.5 79t70.5 57t110 21q61 0 107.5 -19t74 -56t29.5 -90h-92q-2 28 -15 50.5t-38.5 36.5t-65.5 14q-52 0 -82.5 -21t-30.5 -64q0 -25 14 -43.5t49 -35.5t98 -38q62 -20 107 -45t69.5 -59t24.5 -84q0 -43 -22 -79.5t-66 -61.5t-110 -35l9 35q42 -15 78 -35t58 -48.5 t22 -71.5t-24 -79t-69.5 -57.5t-110.5 -21.5zM290 143q70 0 108 34.5t38 79.5q0 49 -40.5 81.5t-109.5 32.5q-70 0 -108 -34t-38 -80q0 -47 40 -80.5t110 -33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 314,
    d: "M75 622q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM239 622q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 793,
    d: "M397 -6q-103 0 -181.5 45.5t-122 125.5t-43.5 184q0 105 43.5 184.5t122 125t181.5 45.5t181 -45.5t121.5 -125t43.5 -184.5q0 -104 -43.5 -184t-121.5 -125.5t-181 -45.5zM397 34q93 0 161 40t105 111t37 164q0 95 -37 165.5t-105 110t-161 39.5q-94 0 -162 -39.5 t-105 -110t-37 -165.5q0 -93 37 -164t105 -111t162 -40zM398 118q-64 0 -113.5 28t-77.5 80t-28 123t28 122.5t77.5 80t113.5 28.5q50 0 89.5 -15t67.5 -45t42 -77l-70 -23q-16 47 -48.5 71.5t-80.5 24.5q-41 0 -73 -19t-50.5 -56t-18.5 -92t18.5 -92.5t50.5 -56.5t73 -19 q56 0 90 30t47 78l69 -17q-11 -44 -38.5 -79t-69 -55t-98.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 451,
    d: "M33 530q0 53 22 93.5t60 63t85 22.5q50 0 82.5 -19.5t48.5 -47.5q18 -26 26 -54.5t8 -57.5q0 -30 -8 -60.5t-26 -56.5q-15 -28 -48 -47t-81 -19t-86 23.5t-60.5 65t-22.5 94.5zM109 529q0 -59 33 -92t77 -33q46 0 79 32.5t33 91.5t-33 91.5t-79 32.5q-44 0 -77 -32 t-33 -91zM331 385v318h73v-350h-41q-14 0 -23 9t-9 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 462,
    d: "M231 120h-90l-96 175l96 175h90l-99 -175zM412 120h-90l-96 175l96 175h90l-99 -175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 625,
    d: "M28 433h565v-214h-91v141h-474v73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 510,
    d: "M256 297q-60 0 -106 26.5t-72 73t-26 105.5t26.5 105t72 73t104.5 27q60 0 105.5 -27t71.5 -73t26 -105t-26 -105.5t-71.5 -73t-104.5 -26.5zM256 337q73 0 116.5 46t43.5 119t-43.5 119t-116.5 46t-117 -46t-44 -119t44 -119t117 -46zM293 396q0 15 -4 34t-18 32.5 t-44 13.5v-80h-53v215h97q34 0 54 -18t20 -49q0 -40 -34 -58q17 -8 26 -23t13 -32.5t4 -34.5h-61zM227 520h40q11 0 18.5 5t7.5 17q0 11 -7.5 16.5t-18.5 5.5h-40v-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 387,
    d: "M17 710h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 411,
    d: "M204 347q-53 0 -92 22t-61 62t-22 92q0 55 22.5 94.5t63 61t91.5 21.5t91 -21.5t62.5 -61t22.5 -94.5q0 -52 -23.5 -92t-63.5 -62t-91 -22zM204 403q42 0 73 30.5t31 90.5t-30.5 91t-73.5 31q-41 0 -71.5 -31t-30.5 -91t29.5 -90.5t72.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 625,
    d: "M356 625v-459h-86v459h86zM58 454h509v-77h-509v77zM58 197h509v-78h-509v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B2",
    unicode: "\xB2",
    horizAdvX: 331,
    d: "M160 699q39 0 67.5 -15t43.5 -40t15 -55q0 -40 -22.5 -70t-70.5 -63l-78 -56h175v-59h-258v53l109 87q30 24 49 48.5t19 56.5q0 27 -14.5 42t-37.5 15q-25 0 -39.5 -21t-15.5 -43l-72 13q2 28 17.5 52t44 39.5t68.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B3",
    unicode: "\xB3",
    horizAdvX: 322,
    d: "M149 336q-25 0 -46 6t-38 17t-27.5 28.5t-14.5 39.5l60 17q5 -25 22.5 -39t42.5 -14q28 0 44.5 13.5t16.5 37.5q0 25 -17.5 38t-45.5 13h-43v49h41q28 0 45.5 13t17.5 37q0 23 -16 37t-44 14q-26 0 -40 -11.5t-22 -31.5l-59 25q11 25 28 41t41.5 24.5t57.5 8.5 q37 0 67 -13.5t47.5 -37t17.5 -52.5q0 -31 -17.5 -51t-45.5 -28v-2q27 -8 46 -28.5t19 -53.5q0 -40 -37.5 -68.5t-100.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 247,
    d: "M230 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B5",
    unicode: "\xB5",
    horizAdvX: 646,
    d: "M569 0h-92v549h92v-549zM497 169q-9 -59 -38 -98t-71 -58.5t-93 -19.5q-40 0 -76.5 17t-57.5 58l8 5v-333h-91v809h91v-299q0 -89 42.5 -133t111.5 -44t111.5 43.5t42.5 131.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 597,
    d: "M520 693v-693h-82v620h-77v-620h-82v286q-81 0 -136 27t-83 73t-28 103t25 103t77.5 73.5t133.5 27.5h252z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 232,
    d: "M119 278q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 272,
    d: "M126 -57q38 0 67.5 -11t45.5 -33t16 -55q0 -32 -15.5 -55.5t-43 -36t-63.5 -12.5h-116v60h98q32 0 48 10t16 34q0 23 -16 32.5t-48 9.5h-51v121h62v-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B9",
    unicode: "\xB9",
    horizAdvX: 228,
    d: "M110 341v283q-10 -27 -35 -41.5t-50 -14.5v70q27 0 51 15.5t32 39.5h75v-352h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 437,
    d: "M217 346q-53 0 -94.5 23t-65.5 64t-24 95q0 55 24.5 95.5t66.5 63t94 22.5q54 0 96 -22.5t66 -63t24 -95.5q0 -54 -24.5 -95t-67 -64t-95.5 -23zM217 405q44 0 78 31t34 91q0 61 -33.5 93t-78.5 32q-43 0 -75.5 -32t-32.5 -93q0 -60 32 -91t76 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 462,
    d: "M231 120l99 175l-99 175h90l96 -175l-96 -175h-90zM50 120l99 175l-99 175h90l96 -175l-96 -175h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 642,
    d: "M437 693h86l-374 -693h-87zM606 117v-48h-48v-69h-73v69h-182v43l157 242h98v-237h48zM487 117v174l-111 -174h111zM123 341v283q-10 -27 -35 -41.5t-50 -14.5v70q27 0 51 15.5t32 39.5h75v-352h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 676,
    d: "M423 693h88l-366 -693h-87zM122 341v283q-11 -27 -36 -41.5t-50 -14.5v70q28 0 51.5 15.5t31.5 39.5h76v-352h-73zM498 346q40 0 68 -15t43.5 -40t15.5 -55q0 -40 -23 -70t-70 -63l-78 -56h174v-59h-258v53l110 87q30 24 49 48.5t19 56.5q0 27 -14.5 42t-37.5 15 q-26 0 -40.5 -21t-15.5 -43l-71 13q2 28 17.5 52t44 39.5t67.5 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 711,
    d: "M532 693h87l-390 -693h-86zM684 117v-48h-47v-69h-73v69h-183v43l157 242h99v-237h47zM566 117v174l-111 -174h111zM161 336q-24 0 -45.5 6t-38.5 17t-27.5 28.5t-13.5 39.5l60 17q4 -25 22 -39t43 -14q27 0 44 13.5t17 37.5q0 25 -18 38t-46 13h-42v49h41q27 0 44.5 13 t17.5 37q0 23 -16 37t-43 14t-41 -11.5t-21 -31.5l-59 25q11 25 28 41t41.5 24.5t56.5 8.5q37 0 67 -13.5t47.5 -37t17.5 -52.5q0 -31 -17.5 -51t-44.5 -28v-2q27 -8 46 -28.5t19 -53.5q0 -40 -38 -68.5t-101 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 517,
    d: "M370 356l4 -158h-54q-50 0 -92.5 -15t-68 -46.5t-25.5 -83.5q0 -56 36.5 -91t97.5 -35q52 0 87 30t45 83l82 -23q-8 -46 -35 -84.5t-72.5 -61t-107.5 -22.5q-65 0 -115 25t-78 70.5t-28 106.5q0 68 31 115t85.5 71.5t124.5 24.5l3 94h80zM322 557q30 0 50.5 -19t20.5 -47 q0 -27 -20.5 -46t-50.5 -19q-29 0 -49.5 19t-20.5 46q0 28 20.5 47t49.5 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 675,
    d: "M391 693l251 -693h-97l-229 642h44l-230 -642h-97l252 693h106zM157 230h356l25 -76h-405zM223 928l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 675,
    d: "M391 693l251 -693h-97l-229 642h44l-230 -642h-97l252 693h106zM157 230h356l25 -76h-405zM436 928v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 675,
    d: "M391 693l251 -693h-97l-229 642h44l-230 -642h-97l252 693h106zM157 230h356l25 -76h-405zM477 727l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 675,
    d: "M391 693l251 -693h-97l-229 642h44l-230 -642h-97l252 693h106zM157 230h356l25 -76h-405zM401 750q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53 q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 675,
    d: "M391 693l251 -693h-97l-229 642h44l-230 -642h-97l252 693h106zM157 230h356l25 -76h-405zM257 767q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM421 767q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16 t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 675,
    d: "M391 693l251 -693h-97l-229 642h44l-230 -642h-97l252 693h106zM157 230h356l25 -76h-405zM446 857q0 -48 -31 -76t-77 -28q-43 0 -74.5 28t-31.5 76q0 49 31.5 77t74.5 28q46 0 77 -28t31 -77zM393 858q0 26 -16 41t-38 15t-37.5 -15t-15.5 -41q0 -25 15.5 -40.5 t37.5 -15.5t38 15.5t16 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 902,
    d: "M12 0l394 693h433v-73h-282v-234h252v-72h-252v-241h282v-73h-374v623l-353 -623h-100zM149 154l39 73h320v-73h-359z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 766,
    d: "M424 -57q38 0 67 -11t45.5 -33t16.5 -55q0 -32 -16 -55.5t-43.5 -36t-62.5 -12.5h-116v60h97q32 0 48 10t16 34q0 23 -16 32.5t-48 9.5h-50v121h62v-64zM391 -7q-73 0 -136 26t-111 73.5t-74.5 112t-26.5 142.5q0 77 26.5 141.5t74.5 112t111 73.5t136 26 q76 0 139.5 -25.5t110 -75t68.5 -121.5l-87 -27q-28 79 -86 123.5t-143 44.5q-73 0 -131 -33t-91.5 -94.5t-33.5 -144.5t33 -144.5t91 -95t130 -33.5q79 0 141.5 42t93.5 116l88 -20q-24 -70 -72 -118.5t-112.5 -74.5t-138.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76zM150 928l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76zM363 928v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76zM404 727l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76zM184 767q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM348 767q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5 t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 368,
    d: "M63 0v76h75v541h-75v76h242v-76h-75v-541h75v-76h-242zM69 928l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 368,
    d: "M63 0v76h75v541h-75v76h242v-76h-75v-541h75v-76h-242zM282 928v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 368,
    d: "M63 0v76h75v541h-75v76h242v-76h-75v-541h75v-76h-242zM323 727l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 368,
    d: "M63 0v76h75v541h-75v76h242v-76h-75v-541h75v-76h-242zM103 767q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM267 767q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5t-37 -15.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 713,
    d: "M83 0v693h218q114 0 196.5 -42.5t127.5 -120.5t45 -185q0 -108 -45 -185t-127.5 -118.5t-196.5 -41.5h-218zM9 305v85h370v-85h-370zM176 73h125q135 0 205 72.5t70 199.5q0 125 -70 199t-205 74h-125v-545z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 704,
    d: "M627 693v-693h-92l-365 549v-549h-92v693h92l365 -548v548h92zM415 750q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 786,
    d: "M393 -7q-73 0 -137 26t-112 73t-74.5 111.5t-26.5 143.5q0 77 26.5 141.5t74.5 112t112 73.5t137 26q74 0 138 -26t111.5 -73.5t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94t33.5 146q0 83 -33.5 144t-91 94.5 t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33zM280 928l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 786,
    d: "M393 -7q-73 0 -137 26t-112 73t-74.5 111.5t-26.5 143.5q0 77 26.5 141.5t74.5 112t112 73.5t137 26q74 0 138 -26t111.5 -73.5t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94t33.5 146q0 83 -33.5 144t-91 94.5 t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33zM493 928v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 786,
    d: "M393 -7q-73 0 -137 26t-112 73t-74.5 111.5t-26.5 143.5q0 77 26.5 141.5t74.5 112t112 73.5t137 26q74 0 138 -26t111.5 -73.5t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94t33.5 146q0 83 -33.5 144t-91 94.5 t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33zM534 727l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 786,
    d: "M393 -7q-73 0 -137 26t-112 73t-74.5 111.5t-26.5 143.5q0 77 26.5 141.5t74.5 112t112 73.5t137 26q74 0 138 -26t111.5 -73.5t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94t33.5 146q0 83 -33.5 144t-91 94.5 t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33zM458 750q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53 q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 786,
    d: "M393 -7q-73 0 -137 26t-112 73t-74.5 111.5t-26.5 143.5q0 77 26.5 141.5t74.5 112t112 73.5t137 26q74 0 138 -26t111.5 -73.5t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94t33.5 146q0 83 -33.5 144t-91 94.5 t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33zM314 767q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM478 767q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16 t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 625,
    d: "M156 584l375 -376l-59 -59l-375 376zM94 210l375 374l60 -61l-374 -374z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 786,
    d: "M677 693h75l-642 -693h-76zM393 -7q-73 0 -136.5 26t-112 73t-75 111.5t-26.5 143.5q0 77 26.5 141.5t75 112t112 73.5t136.5 26q74 0 138 -26t111.5 -73.5t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94 t33.5 146q0 83 -33.5 144t-91 94.5t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436zM222 928l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436zM435 928v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436zM476 727l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436zM256 767q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5 zM420 767q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 585,
    d: "M19 693h103l192 -391h-41l191 391h102l-227 -431v-262h-92v262zM391 928v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 580,
    d: "M78 0v693h91v-145h134q82 0 135.5 -27t79.5 -73t26 -104q0 -53 -24.5 -99t-77 -75t-139.5 -29h-133v-141h-92zM170 214h133q78 0 112.5 36t34.5 94q0 60 -34.5 95.5t-112.5 35.5h-133v-261z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 682,
    d: "M60 561q0 59 25.5 106.5t77.5 75.5t133 28q72 0 120.5 -23.5t73.5 -61.5t25 -81q0 -37 -14 -64.5t-35.5 -48.5t-42.5 -38t-35 -33t-14 -33q0 -14 9.5 -25.5t33.5 -23.5t68 -27q75 -24 107.5 -63.5t32.5 -97.5q0 -47 -23 -83.5t-65.5 -57t-102.5 -20.5q-87 0 -142 47.5 t-63 132.5h94q2 -48 31 -77t80 -29q46 0 71 21t25 59q0 36 -21.5 58t-76.5 40q-79 26 -115 56t-36 77q0 31 14.5 54.5t35.5 43t42 38.5t35.5 40t14.5 47q0 45 -34.5 70.5t-94.5 25.5q-76 0 -109 -38.5t-33 -105.5v-550h-92v561z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM223 783l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM436 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM477 582l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM401 605q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM257 622q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM421 622q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5 t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM446 712q0 -48 -31 -76t-77 -28q-43 0 -74.5 28t-31.5 76q0 49 31.5 77t74.5 28q46 0 77 -28t31 -77zM393 713q0 26 -16 41t-38 15t-37.5 -15t-15.5 -41q0 -25 15.5 -40.5t37.5 -15.5t38 15.5t16 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 1123,
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147t93 98.5t129.5 35.5q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -69t-25.5 -108t25.5 -108.5t67.5 -69.5t92 -24zM825 -7q-64 0 -117.5 20t-92.5 56.5t-60.5 87.5t-21.5 114q0 62 23.5 114t64.5 90.5t93.5 59.5t109.5 21q50 0 92 -13.5t72.5 -37.5t47.5 -55t17 -68q0 -42 -19 -72t-52.5 -50.5t-75.5 -31.5t-88.5 -15.5t-91.5 -3.5 q-17 0 -35.5 1t-34.5 2.5t-26 2.5q6 -39 32 -72t68.5 -52t94.5 -19q40 0 76 14t65 36t47 45l68 -50q-27 -36 -66 -64t-87 -44t-103 -16zM727 285q40 0 81.5 4.5t76 15t56 29.5t21.5 47t-17.5 49.5t-47.5 34t-68 12.5q-57 0 -103 -26.5t-72.5 -69.5t-28.5 -91q17 -2 44 -3.5 t58 -1.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 607,
    d: "M310 -7q-78 0 -138.5 34.5t-94.5 98t-34 149.5t34 149t94.5 97.5t138.5 34.5q46 0 85 -10t70 -31t53.5 -52.5t36.5 -73.5l-87 -28q-19 57 -58.5 87t-99.5 30q-49 0 -88.5 -23t-62 -68t-22.5 -112t22.5 -112.5t62 -68.5t88.5 -23q69 0 111 36.5t57 95.5l85 -21 q-14 -54 -47.5 -97t-84.5 -67.5t-121 -24.5zM230 -260v60h97q32 0 48 10t16 34q0 23 -16 32.5t-48 9.5h-50v121h62v-64q38 0 67 -11t45.5 -33t16.5 -55q0 -32 -16 -55.5t-43.5 -36t-62.5 -12.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 623,
    d: "M334 -7q-64 0 -117.5 20t-92.5 56.5t-60 87.5t-21 114q0 62 23.5 114t64 90.5t93 59.5t109.5 21q51 0 93 -13.5t72.5 -37.5t47 -55t16.5 -68q0 -52 -29 -86.5t-77 -54t-105.5 -27t-115.5 -5.5q-16 0 -35 1t-35 2.5t-25 2.5q6 -39 32 -72t68 -52t94 -19q40 0 76.5 14 t65 36t46.5 45l68 -50q-26 -36 -65 -64t-87 -44t-104 -16zM237 285q40 0 81 4.5t76 15t56.5 29.5t21.5 47t-17.5 49.5t-48 34t-68.5 12.5q-57 0 -102.5 -26.5t-72 -69.5t-29.5 -91q18 -2 44.5 -3.5t58.5 -1.5zM202 783l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 623,
    d: "M334 -7q-64 0 -117.5 20t-92.5 56.5t-60 87.5t-21 114q0 62 23.5 114t64 90.5t93 59.5t109.5 21q51 0 93 -13.5t72.5 -37.5t47 -55t16.5 -68q0 -52 -29 -86.5t-77 -54t-105.5 -27t-115.5 -5.5q-16 0 -35 1t-35 2.5t-25 2.5q6 -39 32 -72t68 -52t94 -19q40 0 76.5 14 t65 36t46.5 45l68 -50q-26 -36 -65 -64t-87 -44t-104 -16zM237 285q40 0 81 4.5t76 15t56.5 29.5t21.5 47t-17.5 49.5t-48 34t-68.5 12.5q-57 0 -102.5 -26.5t-72 -69.5t-29.5 -91q18 -2 44.5 -3.5t58.5 -1.5zM415 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 623,
    d: "M334 -7q-64 0 -117.5 20t-92.5 56.5t-60 87.5t-21 114q0 62 23.5 114t64 90.5t93 59.5t109.5 21q51 0 93 -13.5t72.5 -37.5t47 -55t16.5 -68q0 -52 -29 -86.5t-77 -54t-105.5 -27t-115.5 -5.5q-16 0 -35 1t-35 2.5t-25 2.5q6 -39 32 -72t68 -52t94 -19q40 0 76.5 14 t65 36t46.5 45l68 -50q-26 -36 -65 -64t-87 -44t-104 -16zM237 285q40 0 81 4.5t76 15t56.5 29.5t21.5 47t-17.5 49.5t-48 34t-68.5 12.5q-57 0 -102.5 -26.5t-72 -69.5t-29.5 -91q18 -2 44.5 -3.5t58.5 -1.5zM456 582l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 623,
    d: "M334 -7q-64 0 -117.5 20t-92.5 56.5t-60 87.5t-21 114q0 62 23.5 114t64 90.5t93 59.5t109.5 21q51 0 93 -13.5t72.5 -37.5t47 -55t16.5 -68q0 -52 -29 -86.5t-77 -54t-105.5 -27t-115.5 -5.5q-16 0 -35 1t-35 2.5t-25 2.5q6 -39 32 -72t68 -52t94 -19q40 0 76.5 14 t65 36t46.5 45l68 -50q-26 -36 -65 -64t-87 -44t-104 -16zM237 285q40 0 81 4.5t76 15t56.5 29.5t21.5 47t-17.5 49.5t-48 34t-68.5 12.5q-57 0 -102.5 -26.5t-72 -69.5t-29.5 -91q18 -2 44.5 -3.5t58.5 -1.5zM236 622q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5 t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM400 622q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 247,
    d: "M78 549h92v-549h-92v549zM8 783l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 247,
    d: "M78 549h92v-549h-92v549zM221 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 247,
    d: "M78 549h92v-549h-92v549zM262 582l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 247,
    d: "M78 549h92v-549h-92v549zM42 622q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM206 622q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 638,
    d: "M553 743v-51l-292 -98v51zM316 70q49 0 91 23t68.5 69t26.5 113q0 68 -26 113t-68 68t-90 23q-49 0 -90 -22.5t-66 -67t-25 -111.5q0 -68 24 -114.5t65 -70t90 -23.5zM311 557q68 0 117 -29t77 -80h-7q-16 50 -45 100t-71.5 98.5t-99.5 93.5h94q72 -59 121 -126 t74 -141.5t25 -157.5q0 -108 -36.5 -179.5t-99.5 -107.5t-144 -36q-80 0 -141.5 35.5t-96.5 100t-35 150.5q0 85 35.5 147.5t96 97t136.5 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 641,
    d: "M78 0v549h92v-117q12 34 39.5 62t65.5 45t81 17q65 0 113 -29t74 -81t26 -123v-323h-91v300q0 83 -42 129.5t-110 46.5q-44 0 -79.5 -24.5t-56 -67.5t-20.5 -99v-285h-92zM384 605q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79 t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 640,
    d: "M317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22t-67 -66.5t-25.5 -112.5t25 -113 t66 -67t89 -22zM205 789l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 640,
    d: "M317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22t-67 -66.5t-25.5 -112.5t25 -113 t66 -67t89 -22zM418 789v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 640,
    d: "M317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22t-67 -66.5t-25.5 -112.5t25 -113 t66 -67t89 -22zM459 588l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 640,
    d: "M317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22t-67 -66.5t-25.5 -112.5t25 -113 t66 -67t89 -22zM383 611q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 640,
    d: "M317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22t-67 -66.5t-25.5 -112.5t25 -113 t66 -67t89 -22zM239 628q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM403 628q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 625,
    d: "M58 405h510v-77h-510v77zM324 89q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5zM324 519q-30 0 -50.5 19t-20.5 47q0 27 20.5 46t50.5 19q29 0 49.5 -19t20.5 -46q0 -28 -20.5 -47t-49.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 640,
    d: "M538 549h65l-499 -549h-66zM317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22 t-67 -66.5t-25.5 -112.5t25 -113t66 -67t89 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 641,
    d: "M472 54v495h92v-549h-38q-24 0 -39 15t-15 39zM288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5l20 -32q-1 -81 -29.5 -133.5t-74 -78.5t-100.5 -26zM201 783l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 641,
    d: "M472 54v495h92v-549h-38q-24 0 -39 15t-15 39zM288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5l20 -32q-1 -81 -29.5 -133.5t-74 -78.5t-100.5 -26zM414 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 641,
    d: "M472 54v495h92v-549h-38q-24 0 -39 15t-15 39zM288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5l20 -32q-1 -81 -29.5 -133.5t-74 -78.5t-100.5 -26zM455 582l-138 85l-139 -85v73l139 83 l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 641,
    d: "M472 54v495h92v-549h-38q-24 0 -39 15t-15 39zM288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5l20 -32q-1 -81 -29.5 -133.5t-74 -78.5t-100.5 -26zM235 622q-21 0 -36.5 15.5t-15.5 37.5 t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM399 622q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 615,
    d: "M458 -9v558h92v-558q0 -56 -17 -103t-50 -81.5t-80.5 -54t-109.5 -19.5t-113 21t-87.5 62t-57.5 102l85 31q23 -66 69 -101t103 -35q77 0 121.5 47.5t44.5 130.5zM484 260q-1 -76 -20.5 -126t-50 -78.5t-66.5 -40t-72 -11.5q-65 0 -114 28.5t-75.5 80.5t-26.5 124v312h92 v-290q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55 67t19.5 98.5zM400 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    d: "M78 -260v1000h91v-307q25 53 77.5 88t127.5 35q74 0 132.5 -34.5t92.5 -97t34 -148.5q0 -85 -34 -148.5t-92.5 -99t-132.5 -35.5q-75 0 -127 36t-78 91v-380h-91zM354 73q51 0 93 24t67.5 69.5t25.5 109.5q0 65 -25.5 109.5t-67.5 67.5t-93 23q-48 0 -90.5 -24t-68.5 -69 t-26 -108q0 -64 26 -109t68.5 -69t90.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 615,
    d: "M458 -9v558h92v-558q0 -56 -17 -103t-50 -81.5t-80.5 -54t-109.5 -19.5t-113 21t-87.5 62t-57.5 102l85 31q23 -66 69 -101t103 -35q77 0 121.5 47.5t44.5 130.5zM484 260q-1 -76 -20.5 -126t-50 -78.5t-66.5 -40t-72 -11.5q-65 0 -114 28.5t-75.5 80.5t-26.5 124v312h92 v-290q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55 67t19.5 98.5zM221 622q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM385 622q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5 t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 675,
    d: "M391 693l251 -693h-97l-229 642h44l-230 -642h-97l252 693h106zM157 230h356l25 -76h-405zM162 855h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM162 710h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 675,
    d: "M391 693l251 -693h-97l-229 642h44l-230 -642h-97l252 693h106zM157 230h356l25 -76h-405zM338 747q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM338 602q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 675,
    d: "M618 48l24 -48l-54 -27q-34 -16 -47 -33t-13 -36q0 -23 16 -36t42 -13q31 0 66 14v-61q-17 -6 -37 -10t-40 -4q-30 0 -58.5 10t-46.5 32t-18 58q0 25 11.5 47.5t37 44t69.5 40.5zM391 693l251 -693h-97l-229 642h44l-230 -642h-97l252 693h106zM157 230h356l25 -76h-405z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM532 -202q-30 0 -58.5 10t-46.5 31.5t-18 57.5q0 25 11 48t36.5 44.5t69.5 38.5l49 20 l24 -48l-54 -27q-34 -16 -47 -32.5t-13 -35.5q0 -22 16 -34t42 -12q30 0 65 14v-61q-16 -6 -36 -10t-40 -4zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 766,
    d: "M494 934v-80l-213 -114v69zM391 -7q-73 0 -136 26t-111 73.5t-74.5 112t-26.5 142.5q0 77 26.5 141.5t74.5 112t111 73.5t136 26q76 0 139.5 -25.5t110 -75t68.5 -121.5l-87 -27q-28 79 -86 123.5t-143 44.5q-73 0 -131 -33t-91.5 -94.5t-33.5 -144.5t33 -144.5t91 -95 t130 -33.5q79 0 141.5 42t93.5 116l88 -20q-24 -70 -72 -118.5t-112.5 -74.5t-138.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 607,
    d: "M310 -7q-78 0 -138.5 34.5t-94.5 98t-34 149.5t34 149t94.5 97.5t138.5 34.5q46 0 85 -10t70 -31t53.5 -52.5t36.5 -73.5l-87 -28q-19 57 -58.5 87t-99.5 30q-49 0 -88.5 -23t-62 -68t-22.5 -112t22.5 -112.5t62 -68.5t88.5 -23q69 0 111 36.5t57 95.5l85 -21 q-14 -54 -47.5 -97t-84.5 -67.5t-121 -24.5zM189 589v69l213 125v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 766,
    d: "M391 -7q-73 0 -136 26t-111 73t-74.5 112t-26.5 143q0 77 26.5 141.5t74.5 112t111 73.5t136 26q76 0 139.5 -25.5t110 -75t68.5 -121.5l-87 -27q-28 79 -86 123.5t-143 44.5q-73 0 -131 -33t-91.5 -94.5t-33.5 -144.5t33 -144.5t91 -95t130 -33.5q79 0 141.5 42 t93.5 116l88 -20q-24 -70 -72 -118.5t-112.5 -74.5t-138.5 -26zM397 768q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 607,
    d: "M310 -7q-78 0 -138.5 34.5t-94.5 98t-34 149.5t34 149t94.5 97.5t138.5 34.5q46 0 85 -10t70 -31t53.5 -52.5t36.5 -73.5l-87 -28q-19 57 -58.5 87t-99.5 30q-49 0 -88.5 -23t-62 -68t-22.5 -112t22.5 -112.5t62 -68.5t88.5 -23q69 0 111 36.5t57 95.5l85 -21 q-14 -54 -47.5 -97t-84.5 -67.5t-121 -24.5zM304 613q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -15.5t15.5 -37.5t-15.5 -37.5t-37.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 766,
    d: "M535 902v-72l-138 -83l-139 83v72l139 -84zM391 -7q-73 0 -136 26t-111 73.5t-74.5 112t-26.5 142.5q0 77 26.5 141.5t74.5 112t111 73.5t136 26q76 0 139.5 -25.5t110 -75t68.5 -121.5l-87 -27q-28 79 -86 123.5t-143 44.5q-73 0 -131 -33t-91.5 -94.5t-33.5 -144.5 t33 -144.5t91 -95t130 -33.5q79 0 141.5 42t93.5 116l88 -20q-24 -70 -72 -118.5t-112.5 -74.5t-138.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 607,
    d: "M310 -7q-78 0 -138.5 34.5t-94.5 98t-34 149.5t34 149t94.5 97.5t138.5 34.5q46 0 85 -10t70 -31t53.5 -52.5t36.5 -73.5l-87 -28q-19 57 -58.5 87t-99.5 30q-49 0 -88.5 -23t-62 -68t-22.5 -112t22.5 -112.5t62 -68.5t88.5 -23q69 0 111 36.5t57 95.5l85 -21 q-14 -54 -47.5 -97t-84.5 -67.5t-121 -24.5zM304 597l-138 82v73l138 -85l139 85v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 708,
    d: "M78 0v693h217q114 0 196.5 -42.5t127.5 -120.5t45 -185q0 -108 -45 -185t-127.5 -118.5t-196.5 -41.5h-217zM170 76h125q136 0 205.5 71t69.5 198q0 125 -69.5 198.5t-205.5 73.5h-125v-541zM490 897v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 771,
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v312h92v-740h-38q-25 0 -39.5 15t-14.5 39v68q-24 -59 -80 -94t-127 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM634 546v46q23 -2 41.5 6t30.5 21.5t13 26.5q-10 -9 -29 -9q-21 0 -37.5 12t-16.5 39q0 26 18.5 42t44.5 16q20 0 35 -11.5t23.5 -29t8.5 -36.5q0 -40 -18.5 -68.5t-49 -43t-64.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 713,
    d: "M83 0v693h218q114 0 196.5 -42.5t127.5 -120.5t45 -185q0 -108 -45 -185t-127.5 -118.5t-196.5 -41.5h-218zM9 305v85h370v-85h-370zM176 73h125q135 0 205 72.5t70 199.5q0 125 -70 199t-205 74h-125v-545z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 675,
    d: "M300 672h362v-63h-362v63zM300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147.5t93 98.5t129.5 35q73 0 128 -34.5t79 -93.5v312h92v-740h-38q-25 0 -39.5 15t-14.5 39v68q-24 -59 -80 -94t-127 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5 t-67.5 68.5t-92 24t-92 -24t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76zM89 855h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 623,
    d: "M334 -7q-64 0 -117.5 20t-92.5 56.5t-60 87.5t-21 114q0 62 23.5 114t64 90.5t93 59.5t109.5 21q51 0 93 -13.5t72.5 -37.5t47 -55t16.5 -68q0 -52 -29 -86.5t-77 -54t-105.5 -27t-115.5 -5.5q-16 0 -35 1t-35 2.5t-25 2.5q6 -39 32 -72t68 -52t94 -19q40 0 76.5 14 t65 36t46.5 45l68 -50q-26 -36 -65 -64t-87 -44t-104 -16zM237 285q40 0 81 4.5t76 15t56.5 29.5t21.5 47t-17.5 49.5t-48 34t-68.5 12.5q-57 0 -102.5 -26.5t-72 -69.5t-29.5 -91q18 -2 44.5 -3.5t58.5 -1.5zM141 710h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76zM265 747q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 623,
    d: "M334 -7q-64 0 -117.5 20t-92.5 56.5t-60 87.5t-21 114q0 62 23.5 114t64 90.5t93 59.5t109.5 21q51 0 93 -13.5t72.5 -37.5t47 -55t16.5 -68q0 -52 -29 -86.5t-77 -54t-105.5 -27t-115.5 -5.5q-16 0 -35 1t-35 2.5t-25 2.5q6 -39 32 -72t68 -52t94 -19q40 0 76.5 14 t65 36t46.5 45l68 -50q-26 -36 -65 -64t-87 -44t-104 -16zM237 285q40 0 81 4.5t76 15t56.5 29.5t21.5 47t-17.5 49.5t-48 34t-68.5 12.5q-57 0 -102.5 -26.5t-72 -69.5t-29.5 -91q18 -2 44.5 -3.5t58.5 -1.5zM317 602q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56 t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76zM265 751q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -15.5t15.5 -37.5t-16 -37.5t-38 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 623,
    d: "M334 -7q-64 0 -117.5 20t-92.5 56.5t-60 87.5t-21 114q0 62 23.5 114t64 90.5t93 59.5t109.5 21q51 0 93 -13.5t72.5 -37.5t47 -55t16.5 -68q0 -52 -29 -86.5t-77 -54t-105.5 -27t-115.5 -5.5q-16 0 -35 1t-35 2.5t-25 2.5q6 -39 32 -72t68 -52t94 -19q40 0 76.5 14 t65 36t46.5 45l68 -50q-26 -36 -65 -64t-87 -44t-104 -16zM237 285q40 0 81 4.5t76 15t56.5 29.5t21.5 47t-17.5 49.5t-48 34t-68.5 12.5q-57 0 -102.5 -26.5t-72 -69.5t-29.5 -91q18 -2 44.5 -3.5t58.5 -1.5zM317 606q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5 t37.5 -15.5t15.5 -37.5t-16 -37.5t-38 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76zM428 48l24 -48l-54 -27q-34 -16 -47 -33t-13 -36q0 -23 16 -36t42 -13q30 0 65 14v-61q-16 -6 -36 -10t-40 -4q-30 0 -58.5 10t-46.5 32t-18 58q0 25 11 47.5t37 44t69 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 640,
    d: "M320 -206q-29 0 -57.5 10t-47 32t-18.5 58q0 19 7 37.5t22.5 35.5t40.5 33q-65 14 -115.5 50t-79.5 92.5t-29 128.5q0 63 23.5 115t64 90.5t93 59.5t109.5 21q65 0 118.5 -23.5t85.5 -63t32 -88.5t-28 -82.5t-74.5 -54t-103.5 -29.5t-115 -9q-13 0 -32 0.5t-38.5 2 t-37.5 3.5q7 -40 34.5 -71.5t69.5 -50.5t92 -19q33 0 68 10.5t67 32t57 53.5l70 -52q-43 -54 -100 -84t-120 -37l-45 -22q-33 -16 -46.5 -33t-13.5 -36q0 -23 16 -36t43 -13q30 0 65 14v-61q-17 -6 -37 -10t-40 -4zM234 286q44 0 87 4.5t78.5 16t56.5 31t21 49.5 q0 28 -18 48t-49 31.5t-70 11.5q-57 0 -103 -26.5t-73.5 -69.5t-30.5 -90q20 -3 46 -4.5t55 -1.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76zM404 897v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 623,
    d: "M334 -7q-64 0 -117.5 20t-92.5 56.5t-60 87.5t-21 114q0 62 23.5 114t64 90.5t93 59.5t109.5 21q51 0 93 -13.5t72.5 -37.5t47 -55t16.5 -68q0 -52 -29 -86.5t-77 -54t-105.5 -27t-115.5 -5.5q-16 0 -35 1t-35 2.5t-25 2.5q6 -39 32 -72t68 -52t94 -19q40 0 76.5 14 t65 36t46.5 45l68 -50q-26 -36 -65 -64t-87 -44t-104 -16zM237 285q40 0 81 4.5t76 15t56.5 29.5t21.5 47t-17.5 49.5t-48 34t-68.5 12.5q-57 0 -102.5 -26.5t-72 -69.5t-29.5 -91q18 -2 44.5 -3.5t58.5 -1.5zM456 752v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 775,
    d: "M612 465q-10 29 -29.5 56t-48 49t-64 35.5t-78.5 13.5q-73 0 -130.5 -34t-91 -95t-33.5 -143t32 -143.5t90.5 -95.5t134.5 -34q52 0 93.5 21.5t72 56t48 75t20.5 77.5h-262v76h366v-380h-85v221l11 3q-3 -19 -14.5 -48t-32.5 -61t-52.5 -59.5t-73.5 -45t-96 -17.5 q-72 0 -134.5 26t-110 73.5t-74.5 112t-27 142.5q0 77 26 142t73.5 112t111.5 73t139 26q109 0 191 -53t119 -149zM392 747q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    d: "M333 -267q-69 0 -123.5 22.5t-93.5 63.5t-61 94l83 37q28 -62 78.5 -99t116.5 -37q51 0 90 21t61.5 60.5t22.5 95.5v131q-24 -59 -80 -94t-127 -35q-73 0 -131.5 35.5t-92 99t-33.5 147.5t33.5 147.5t92 98.5t131.5 35t128 -34.5t79 -93.5v121h92v-557 q0 -56 -18.5 -103.5t-53 -82t-84 -54t-110.5 -19.5zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM338 602q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56 t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 775,
    d: "M612 465q-10 29 -29.5 56t-48 49t-64 35.5t-78.5 13.5q-73 0 -130.5 -34t-91 -95t-33.5 -143t32 -143.5t90.5 -95.5t134.5 -34q52 0 93.5 21.5t72 56t48 75t20.5 77.5h-262v76h366v-380h-85v221l11 3q-3 -19 -14.5 -48t-32.5 -61t-52.5 -59.5t-73.5 -45t-96 -17.5 q-72 0 -134.5 26t-110 73.5t-74.5 112t-27 142.5q0 77 26 142t73.5 112t111.5 73t139 26q109 0 191 -53t119 -149zM392 751q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -15.5t15.5 -37.5t-16 -37.5t-38 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    d: "M333 -267q-69 0 -123.5 22.5t-93.5 63.5t-61 94l83 37q28 -62 78.5 -99t116.5 -37q51 0 90 21t61.5 60.5t22.5 95.5v131q-24 -59 -80 -94t-127 -35q-73 0 -131.5 35.5t-92 99t-33.5 147.5t33.5 147.5t92 98.5t131.5 35t128 -34.5t79 -93.5v121h92v-557 q0 -56 -18.5 -103.5t-53 -82t-84 -54t-110.5 -19.5zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24zM338 606q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5 t37.5 -15.5t15.5 -37.5t-16 -37.5t-38 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0122",
    unicode: "\u0122",
    horizAdvX: 775,
    d: "M333 -248v46q22 -2 41 6t30.5 21.5t13.5 26.5q-11 -9 -29 -9q-22 0 -38 12t-16 39q0 26 18 42t44 16q21 0 36 -11.5t23.5 -29t8.5 -36.5q0 -40 -19 -68.5t-49 -43t-64 -11.5zM612 465q-10 29 -29.5 56t-48 49t-64 35.5t-78.5 13.5q-73 0 -130.5 -34t-91 -95t-33.5 -143 t32 -143.5t90.5 -95.5t134.5 -34q52 0 93.5 21.5t72 56t48 75t20.5 77.5h-262v76h366v-380h-85v221l11 3q-3 -19 -14.5 -48t-32.5 -61t-52.5 -59.5t-73.5 -45t-96 -17.5q-72 0 -134.5 26t-110 73.5t-74.5 112t-27 142.5q0 77 26 142t73.5 112t111.5 73t139 26q109 0 191 -53 t119 -149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0123",
    unicode: "\u0123",
    d: "M394 796v-46q-22 2 -41 -6t-30.5 -21t-13.5 -27q11 9 29 9q22 0 38 -11.5t16 -39.5q0 -26 -18 -42t-44 -16q-20 0 -35.5 11.5t-24 29t-8.5 36.5q0 40 19 68.5t49.5 43t63.5 11.5zM333 -267q-69 0 -123.5 22.5t-93.5 63.5t-61 94l83 37q28 -62 78.5 -99t116.5 -37 q51 0 90 21t61.5 60.5t22.5 95.5v131q-24 -59 -80 -94t-127 -35q-73 0 -131.5 35.5t-92 99t-33.5 147.5t33.5 147.5t92 98.5t131.5 35t128 -34.5t79 -93.5v121h92v-557q0 -56 -18.5 -103.5t-53 -82t-84 -54t-110.5 -19.5zM322 73q50 0 92 24t67.5 69.5t25.5 108.5 q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24t-67.5 -68.5t-25.5 -108.5q0 -63 25.5 -108.5t67.5 -69.5t92 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 731,
    d: "M97 693h92v-693h-92v693zM542 693h92v-693h-92v693zM171 389h395v-75h-395v75zM40 615h651v-76h-651v76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 641,
    d: "M22 609v63h361v-63h-361zM78 0v740h92v-308q12 34 39.5 62t65.5 45t81 17q65 0 113 -29t74 -81t26 -123v-323h-91v300q0 83 -42 129.5t-110 46.5q-44 0 -79.5 -24.5t-56 -67.5t-20.5 -99v-285h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 368,
    d: "M63 0v76h75v541h-75v76h242v-76h-75v-541h75v-76h-242zM247 750q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 247,
    d: "M78 549h92v-549h-92v549zM186 605q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 368,
    d: "M63 0v76h75v541h-75v76h242v-76h-75v-541h75v-76h-242zM8 855h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 247,
    d: "M78 549h92v-549h-92v549zM-53 710h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 368,
    d: "M63 0v76h75v541h-75v76h242v-76h-75v-541h75v-76h-242zM184 747q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 247,
    d: "M78 549h92v-549h-92v549zM123 602q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 368,
    d: "M63 0v76h75v541h-75v76h242v-76h-75v-541h75v-76h-242zM206 49l24 -48l-54 -27q-34 -16 -47 -33t-13 -36q0 -23 16 -36t42 -13q30 0 65 14v-61q-16 -6 -36 -10t-40 -4q-30 0 -58.5 10t-46.5 32t-18 58q0 25 11 47.5t37 44t69 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 256,
    d: "M82 0v549h92v-549h-92zM128 637q-29 0 -50 19t-21 47q0 29 20.5 48t50.5 19q29 0 50 -19t21 -48q0 -28 -21 -47t-50 -19zM150 49l24 -48l-54 -27q-34 -16 -47 -33t-13 -36q0 -23 16 -36t42 -13q30 0 65 14v-61q-16 -6 -36 -10t-40 -4q-30 0 -58.5 10t-46.5 32t-18 58 q0 25 11 47.5t37 44t69 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 368,
    d: "M63 0v76h75v541h-75v76h242v-76h-75v-541h75v-76h-242zM184 751q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -15.5t15.5 -37.5t-16 -37.5t-38 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 247,
    d: "M78 549h92v-549h-92v549z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0136",
    unicode: "\u0136",
    horizAdvX: 609,
    d: "M258 -248v46q22 -2 41 6t30.5 21.5t13.5 26.5q-11 -9 -29 -9q-22 0 -38 12t-16 39q0 26 18 42t44 16q21 0 36 -11.5t23.5 -29t8.5 -36.5q0 -40 -19 -68.5t-49 -43t-64 -11.5zM78 0v693h92v-299q92 3 154 41t96.5 104.5t42.5 153.5h98q-4 -56 -24.5 -110.5t-53.5 -101 t-74 -79.5t-86 -45q70 -17 126.5 -65t92.5 -122t43 -170h-98q-6 104 -47 173t-110 105t-160 38v-316h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0137",
    unicode: "\u0137",
    horizAdvX: 548,
    d: "M212 -248v46q22 -2 41 6t30.5 21.5t13.5 26.5q-11 -9 -29 -9q-22 0 -38 12t-16 39q0 26 18 42t44 16q21 0 36 -11.5t23.5 -29t8.5 -36.5q0 -40 -19 -68.5t-49 -43t-64 -11.5zM78 0v740h92v-426q61 11 113 42t88.5 79.5t50.5 113.5h99q-15 -69 -52.5 -124t-86 -92.5 t-98.5 -55.5q36 -9 76.5 -34.5t78.5 -62.5t65 -83t36 -97h-99q-10 45 -36.5 85t-64 72t-81.5 52t-89 24v-233h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 433,
    d: "M170 693v-618h243v-75h-335v693h92zM221 928v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 281,
    d: "M78 111v629h92v-621q0 -23 13 -34.5t31 -11.5q11 0 21 4l20 -69q-25 -15 -60 -15q-28 0 -55 12t-44.5 38t-17.5 68zM221 975v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013B",
    unicode: "\u013B",
    horizAdvX: 433,
    d: "M180 -248v46q23 -2 41.5 6t30.5 21.5t13 26.5q-10 -9 -29 -9q-21 0 -37.5 12t-16.5 39q0 26 18.5 42t44.5 16q20 0 35 -11.5t23.5 -29t8.5 -36.5q0 -40 -18.5 -68.5t-49 -43t-64.5 -11.5zM170 693v-618h243v-75h-335v693h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C",
    unicode: "\u013C",
    horizAdvX: 319,
    d: "M81 -248v46q22 -2 41 6t30.5 21.5t13.5 26.5q-11 -9 -29 -9q-22 0 -38 12t-16 39q0 26 18 42t44 16q21 0 36 -11.5t23.5 -29t8.5 -36.5q0 -40 -19 -68.5t-49 -43t-64 -11.5zM72 111v629h92v-621q0 -23 13 -34.5t31 -11.5q12 0 22 4l20 -69q-25 -15 -60 -15q-28 0 -55 12 t-45 38t-18 68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 438,
    d: "M170 693v-618h243v-75h-335v693h92zM303 493v46q23 -2 41.5 6t30.5 21.5t13 26.5q-10 -9 -29 -9q-21 0 -37.5 12t-16.5 39q0 26 18.5 42t44.5 16q20 0 35 -11.5t23.5 -29t8.5 -36.5q0 -40 -18.5 -68.5t-49 -43t-64.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 337,
    d: "M78 111v629h92v-621q0 -23 13 -34.5t31 -11.5q11 0 21 4l20 -69q-25 -15 -60 -15q-28 0 -55 12t-44.5 38t-17.5 68zM216 540v46q23 -2 41.5 6t30.5 21.5t13 26.5q-10 -9 -29 -9q-21 0 -37.5 12t-16.5 39q0 26 18.5 42t44.5 16q20 0 35 -11.5t23.5 -29t8.5 -36.5 q0 -40 -18.5 -68.5t-49 -43t-64.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 437,
    d: "M9 349l283 101v-71l-283 -101v71zM183 693v-622h243v-71h-335v693h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 267,
    d: "M190 -7q-28 0 -53.5 12t-41.5 37.5t-16 64.5v633h92v-630q0 -18 11 -27.5t27 -9.5q6 0 12.5 1.5t15.5 5.5l19 -72q-11 -6 -27.5 -10.5t-38.5 -4.5zM9 308v72l234 90v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 704,
    d: "M627 693v-693h-92l-365 549v-549h-92v693h92l365 -548v548h92zM450 928v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 641,
    d: "M78 0v549h92v-117q12 34 39.5 62t65.5 45t81 17q65 0 113 -29t74 -81t26 -123v-323h-91v300q0 83 -42 129.5t-110 46.5q-44 0 -79.5 -24.5t-56 -67.5t-20.5 -99v-285h-92zM419 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0145",
    unicode: "\u0145",
    horizAdvX: 704,
    d: "M293 -248v46q23 -2 41.5 6t30.5 21.5t13 26.5q-10 -9 -29 -9q-21 0 -37.5 12t-16.5 39q0 26 18.5 42t44.5 16q20 0 35 -11.5t23.5 -29t8.5 -36.5q0 -40 -18.5 -68.5t-49 -43t-64.5 -11.5zM627 693v-693h-92l-365 549v-549h-92v693h92l365 -548v548h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0146",
    unicode: "\u0146",
    horizAdvX: 641,
    d: "M252 -248v46q23 -2 41.5 6t30.5 21.5t13 26.5q-10 -9 -29 -9q-21 0 -37.5 12t-16.5 39q0 26 18.5 42t44.5 16q20 0 35 -11.5t23.5 -29t8.5 -36.5q0 -40 -18.5 -68.5t-49 -43t-64.5 -11.5zM78 0v549h92v-117q12 34 39.5 62t65.5 45t81 17q65 0 113 -29t74 -81t26 -123 v-323h-91v300q0 83 -42 129.5t-110 46.5q-44 0 -79.5 -24.5t-56 -67.5t-20.5 -99v-285h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 704,
    d: "M627 693v-693h-92l-365 549v-549h-92v693h92l365 -548v548h92zM491 897v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 641,
    d: "M78 0v549h92v-117q12 34 39.5 62t65.5 45t81 17q65 0 113 -29t74 -81t26 -123v-323h-91v300q0 83 -42 129.5t-110 46.5q-44 0 -79.5 -24.5t-56 -67.5t-20.5 -99v-285h-92zM460 752v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 786,
    d: "M393 -7q-73 0 -137 26t-112 73t-74.5 111.5t-26.5 143.5q0 77 26.5 141.5t74.5 112t112 73.5t137 26q74 0 138 -26t111.5 -73.5t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94t33.5 146q0 83 -33.5 144t-91 94.5 t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33zM219 855h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 640,
    d: "M317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22t-67 -66.5t-25.5 -112.5t25 -113 t66 -67t89 -22zM144 716h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 786,
    d: "M393 -7q-73 0 -137 26t-112 73t-74.5 111.5t-26.5 143.5q0 77 26.5 141.5t74.5 112t112 73.5t137 26q74 0 138 -26t111.5 -73.5t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94t33.5 146q0 83 -33.5 144t-91 94.5 t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33zM395 747q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 640,
    d: "M317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22t-67 -66.5t-25.5 -112.5t25 -113 t66 -67t89 -22zM320 608q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 786,
    d: "M393 -7q-73 0 -137 26t-112 73t-74.5 111.5t-26.5 143.5q0 77 26.5 141.5t74.5 112t112 73.5t137 26q74 0 138 -26t111.5 -73.5t74.5 -112t27 -141.5q0 -79 -27 -143.5t-74.5 -111.5t-111.5 -73t-138 -26zM393 74q74 0 131.5 33t91 94t33.5 146q0 83 -33.5 144t-91 94.5 t-131.5 33.5q-73 0 -131 -33.5t-91.5 -94.5t-33.5 -144q0 -85 33.5 -146t91.5 -94t131 -33zM429 901l-86 -155h-62l67 155h81zM583 901l-92 -155h-61l72 155h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 640,
    d: "M317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22t-67 -66.5t-25.5 -112.5t25 -113 t66 -67t89 -22zM353 762l-86 -155h-62l67 155h81zM507 762l-92 -155h-61l72 155h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1086,
    d: "M741 620v-234h253v-72h-253v-241h283v-73h-375v141q-38 -69 -107 -108.5t-156 -39.5q-71 0 -133 26t-109.5 73t-74 111.5t-26.5 143.5q0 77 26.5 142t74 112t109.5 73t133 26q87 0 156 -36t107 -104v133h375v-73h-283zM137 347q0 -83 33.5 -144t91.5 -94t131 -33 q74 0 131.5 33t91 94t33.5 144t-33.5 143t-91 93t-131.5 33q-73 0 -131 -33.5t-91.5 -93.5t-33.5 -142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1110,
    d: "M317 -7q-78 0 -140 34.5t-98 98t-36 149.5t37 149t100 97.5t140 34.5q78 0 141 -34.5t99.5 -97.5t36.5 -149t-37.5 -149.5t-101 -98t-141.5 -34.5zM317 73q47 0 89.5 22t69.5 67t27 113t-26.5 112.5t-68.5 66.5t-89 22q-48 0 -89.5 -22t-67 -66.5t-25.5 -112.5t25 -113 t66 -67t89 -22zM811 -7q-64 0 -117.5 20t-92.5 56.5t-60.5 87.5t-21.5 114q0 62 23.5 114t64.5 90.5t93.5 59.5t109.5 21q50 0 92 -13.5t72.5 -37.5t47.5 -55t17 -68q0 -52 -29.5 -86.5t-77.5 -54t-105.5 -27t-114.5 -5.5q-17 0 -35.5 1t-34.5 2.5t-26 2.5q6 -39 32 -72 t68.5 -52t94.5 -19q40 0 76 14t65 36t47 45l68 -50q-27 -36 -66 -64t-87 -44t-103 -16zM713 285q40 0 81.5 4.5t76 15t56 29.5t21.5 47t-17.5 49.5t-47.5 34t-68 12.5q-57 0 -103 -26.5t-72.5 -69.5t-28.5 -91q17 -2 44 -3.5t58 -1.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 647,
    d: "M78 0v693h225q81 0 135 -27.5t80.5 -73t26.5 -102.5q0 -72 -44.5 -120t-114.5 -63q54 -17 97 -58t71 -103t37 -146h-98q-7 85 -39 144.5t-91 92.5q-37 21 -85.5 31t-107.5 10v-278h-92zM170 355h133q74 0 110.5 38.5t36.5 94.5q0 59 -36 94t-111 35h-133v-262zM196 734 v69l213 125v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 375,
    d: "M78 0v549h92v-549h-92zM137 281l33 146q19 61 66 95t112 34v-96q-8 2 -15.5 2.5t-14.5 0.5q-43 0 -76.5 -22.5t-52.5 -63t-19 -96.5h-33zM329 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0156",
    unicode: "\u0156",
    horizAdvX: 647,
    d: "M248 -248v46q22 -2 41 6t30.5 21.5t13.5 26.5q-11 -9 -29 -9q-22 0 -38 12t-16 39q0 26 18 42t44 16q21 0 36 -11.5t23.5 -29t8.5 -36.5q0 -40 -19 -68.5t-49 -43t-64 -11.5zM78 0v693h225q81 0 135 -27.5t80.5 -73t26.5 -102.5q0 -72 -44.5 -120t-114.5 -63 q54 -17 97 -58t71 -103t37 -146h-98q-7 85 -39 144.5t-91 92.5q-37 21 -85.5 31t-107.5 10v-278h-92zM170 355h133q74 0 110.5 38.5t36.5 94.5q0 59 -36 94t-111 35h-133v-262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0157",
    unicode: "\u0157",
    horizAdvX: 385,
    d: "M72 -248v46q23 -2 41.5 6t30.5 21.5t13 26.5q-10 -9 -29 -9q-21 0 -37.5 12t-16.5 39q0 26 18.5 42t44.5 16q20 0 35 -11.5t23.5 -29t8.5 -36.5q0 -40 -19 -68.5t-49 -43t-64 -11.5zM88 0v549h92v-549h-92zM147 281l33 146q19 61 66 95t112 34v-96q-8 2 -15.5 2.5 t-14.5 0.5q-43 0 -76.5 -22.5t-52.5 -63t-19 -96.5h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 647,
    d: "M78 0v693h225q81 0 135 -27.5t80.5 -73t26.5 -102.5q0 -72 -44.5 -120t-114.5 -63q54 -17 97 -58t71 -103t37 -146h-98q-7 85 -39 144.5t-91 92.5q-37 21 -85.5 31t-107.5 10v-278h-92zM170 355h133q74 0 110.5 38.5t36.5 94.5q0 59 -36 94t-111 35h-133v-262zM311 741 l-138 83v72l138 -84l139 84v-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 375,
    d: "M78 0v549h92v-549h-92zM137 281l33 146q19 61 66 95t112 34v-96q-8 2 -15.5 2.5t-14.5 0.5q-43 0 -76.5 -22.5t-52.5 -63t-19 -96.5h-33zM370 752v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 595,
    d: "M305 -7q-68 0 -121.5 25.5t-86 71t-40.5 106.5l96 18q11 -66 50.5 -103t101.5 -37q67 0 103.5 30t36.5 79q0 40 -20.5 63.5t-54 37.5t-73.5 24t-80.5 22t-74 32.5t-54 55.5t-20.5 90q0 58 29 101t81.5 67t121.5 24q63 0 111.5 -25.5t78.5 -65.5t36 -86l-93 -24 q-10 55 -47.5 88t-90.5 33q-37 0 -67 -12t-48 -35.5t-18 -61.5t20.5 -61t54 -36.5t73.5 -24t80 -23t73.5 -33.5t54 -55.5t20.5 -89.5q0 -50 -26.5 -94.5t-78.5 -72.5t-128 -28zM396 933v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 516,
    d: "M266 -7q-60 0 -106 20.5t-74.5 55t-38.5 76.5l86 19q10 -41 44 -67t87 -26q55 0 83.5 22.5t28.5 56.5q0 30 -23.5 47t-60.5 28t-78.5 22t-78.5 28.5t-60 47.5t-23 80q0 43 25 77.5t70.5 55t106.5 20.5q57 0 98 -18.5t66.5 -50.5t34.5 -73l-85 -23q-9 37 -37 62t-80 25 q-51 0 -78.5 -21t-27.5 -53t23 -50t59.5 -29.5t78 -22.5t78 -27.5t59.5 -46t23 -78.5q0 -43 -24.5 -79t-69.5 -57t-106 -21zM353 789v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 595,
    d: "M305 -7q-68 0 -121.5 25.5t-86 71t-40.5 106.5l96 18q11 -66 50.5 -103t101.5 -37q67 0 103.5 30t36.5 79q0 40 -20.5 63.5t-54 37.5t-73.5 24t-80.5 22t-74 32.5t-54 55.5t-20.5 90q0 58 29 101t81.5 67t121.5 24q63 0 111.5 -25.5t78.5 -65.5t36 -86l-93 -24 q-10 55 -47.5 88t-90.5 33q-37 0 -67 -12t-48 -35.5t-18 -61.5t20.5 -61t54 -36.5t73.5 -24t80 -23t73.5 -33.5t54 -55.5t20.5 -89.5q0 -50 -26.5 -94.5t-78.5 -72.5t-128 -28zM337 -62q38 0 67.5 -11t45.5 -33t16 -55q0 -32 -15.5 -55.5t-43 -36t-63.5 -12.5h-116v60h98 q32 0 48 10t16 34q0 23 -16 32.5t-48 9.5h-51v121h62v-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 516,
    d: "M266 -7q-60 0 -106 20.5t-74.5 55t-38.5 76.5l86 19q10 -41 44 -67t87 -26q55 0 83.5 22.5t28.5 56.5q0 30 -23.5 47t-60.5 28t-78.5 22t-78.5 28.5t-60 47.5t-23 80q0 43 25 77.5t70.5 55t106.5 20.5q57 0 98 -18.5t66.5 -50.5t34.5 -73l-85 -23q-9 37 -37 62t-80 25 q-51 0 -78.5 -21t-27.5 -53t23 -50t59.5 -29.5t78 -22.5t78 -27.5t59.5 -46t23 -78.5q0 -43 -24.5 -79t-69.5 -57t-106 -21zM290 -57q38 0 67.5 -11t45.5 -33t16 -55q0 -32 -15.5 -55.5t-43 -36t-63.5 -12.5h-116v60h98q32 0 48 10t16 34q0 23 -16 32.5t-48 9.5h-51v121h62 v-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 595,
    d: "M305 -7q-68 0 -121.5 25.5t-86 71t-40.5 106.5l96 18q11 -66 50.5 -103t101.5 -37q67 0 103.5 30t36.5 79q0 40 -20.5 63.5t-54 37.5t-73.5 24t-80.5 22t-74 32.5t-54 55.5t-20.5 90q0 58 29 101t81.5 67t121.5 24q63 0 111.5 -25.5t78.5 -65.5t36 -86l-93 -24 q-10 55 -47.5 88t-90.5 33q-37 0 -67 -12t-48 -35.5t-18 -61.5t20.5 -61t54 -36.5t73.5 -24t80 -23t73.5 -33.5t54 -55.5t20.5 -89.5q0 -50 -26.5 -94.5t-78.5 -72.5t-128 -28zM437 902v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 516,
    d: "M266 -7q-60 0 -106 20.5t-74.5 55t-38.5 76.5l86 19q10 -41 44 -67t87 -26q55 0 83.5 22.5t28.5 56.5q0 30 -23.5 47t-60.5 28t-78.5 22t-78.5 28.5t-60 47.5t-23 80q0 43 25 77.5t70.5 55t106.5 20.5q57 0 98 -18.5t66.5 -50.5t34.5 -73l-85 -23q-9 37 -37 62t-80 25 q-51 0 -78.5 -21t-27.5 -53t23 -50t59.5 -29.5t78 -22.5t78 -27.5t59.5 -46t23 -78.5q0 -43 -24.5 -79t-69.5 -57t-106 -21zM394 758v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 542,
    d: "M35 693h472v-76h-190v-617h-92v617h-190v76zM304 -57q38 0 67.5 -11t45.5 -33t16 -55q0 -32 -15.5 -55.5t-43 -36t-63.5 -12.5h-116v60h98q32 0 48 10t16 34q0 23 -16 32.5t-48 9.5h-51v121h62v-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 389,
    d: "M253 -7q-57 0 -95.5 38.5t-38.5 100.5v341h-93v76h49q21 0 32.5 11.5t11.5 33.5v92h93v-76q0 -14 -5.5 -27t-16.5 -22t-26 -12h173v-76h-125v-344q0 -26 14.5 -40t34.5 -14q15 0 27.5 5.5t23.5 14.5l45 -63q-21 -20 -47 -29.5t-57 -9.5zM140 -260v60h98q32 0 47.5 10 t15.5 34q0 23 -15.5 32.5t-47.5 9.5h-51v162h62v-105q38 0 67.5 -11t45.5 -33t16 -55q0 -32 -15.5 -55.5t-43 -36t-63.5 -12.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 542,
    d: "M35 693h472v-76h-190v-617h-92v617h-190v76zM410 897v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 385,
    d: "M253 -7q-57 0 -95.5 38.5t-38.5 101.5v340h-93v76h311v-76h-125v-344q0 -26 14.5 -40t34.5 -14q15 0 27.5 5.5t23.5 14.5l45 -63q-21 -19 -47 -29t-57 -10zM75 509v40q21 0 32.5 11.5t11.5 33.5v92h93v-76q0 -14 -5.5 -27t-16.5 -22t-26 -12zM272 618v46q23 -2 41.5 6 t30.5 21.5t13 26.5q-10 -9 -29 -9q-21 0 -37.5 12t-16.5 39q0 26 18.5 42t44.5 16q20 0 35 -11.5t23.5 -29t8.5 -36.5q0 -40 -18.5 -68.5t-49 -43t-64.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436zM400 750q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26 q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 641,
    d: "M472 54v495h92v-549h-38q-24 0 -39 15t-15 39zM288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5l20 -32q-1 -81 -29.5 -133.5t-74 -78.5t-100.5 -26zM379 605q-26 0 -44 11.5t-33.5 23 t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436zM161 855h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 641,
    d: "M472 54v495h92v-549h-38q-24 0 -39 15t-15 39zM288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5l20 -32q-1 -81 -29.5 -133.5t-74 -78.5t-100.5 -26zM140 710h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436zM337 747q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17 q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 641,
    d: "M472 54v495h92v-549h-38q-24 0 -39 15t-15 39zM288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5l20 -32q-1 -81 -29.5 -133.5t-74 -78.5t-100.5 -26zM316 602q-68 0 -105 37.5t-37 93.5v17h55 q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436zM445 857q0 -48 -31 -76t-77 -28q-43 0 -74.5 28t-31.5 76q0 49 31.5 77t74.5 28q46 0 77 -28t31 -77z M392 858q0 26 -16 41t-38 15t-37.5 -15t-15.5 -41q0 -25 15.5 -40.5t37.5 -15.5t38 15.5t16 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 641,
    d: "M472 54v495h92v-549h-38q-24 0 -39 15t-15 39zM288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5l20 -32q-1 -81 -29.5 -133.5t-74 -78.5t-100.5 -26zM424 712q0 -48 -31 -76t-77 -28 q-43 0 -74.5 28t-31.5 76q0 49 31.5 77t74.5 28q46 0 77 -28t31 -77zM371 713q0 26 -16 41t-38 15t-37.5 -15t-15.5 -41q0 -25 15.5 -40.5t37.5 -15.5t38 15.5t16 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436zM371 901l-86 -155h-62l67 155h81zM525 901l-92 -155h-61l72 155h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 641,
    d: "M472 54v495h92v-549h-38q-24 0 -39 15t-15 39zM288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5l20 -32q-1 -81 -29.5 -133.5t-74 -78.5t-100.5 -26zM349 756l-86 -155h-62l67 155h81zM503 756 l-92 -155h-61l72 155h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 676,
    d: "M76 693h92v-437q0 -95 47 -138.5t124 -43.5t123.5 43.5t46.5 138.5v437h92v-436q0 -90 -36 -148.5t-95.5 -87t-131.5 -28.5t-131.5 28.5t-95 87t-35.5 148.5v436zM384 49l25 -48l-55 -27q-33 -16 -46.5 -33.5t-13.5 -36.5q0 -23 16 -36t43 -13q30 0 65 14v-61 q-17 -6 -37 -10t-40 -4q-29 0 -57.5 10t-47 32.5t-18.5 58.5q0 25 11.5 47.5t37.5 44t69 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 641,
    d: "M288 -7q-65 0 -113.5 28.5t-75 80.5t-26.5 124v323h91v-301q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55.5 67t20 98.5v286h92v-549h-38q-24 0 -39 15t-15 39v60q-10 -31 -36.5 -58.5t-64 -45t-83.5 -17.5zM539 48l25 -48l-55 -27q-33 -16 -46.5 -33t-13.5 -36 q0 -23 16 -36t43 -13q30 0 65 14v-61q-17 -6 -37 -10t-40 -4q-29 0 -57.5 10t-47 32t-18.5 58q0 25 11.5 47.5t37.5 44t69 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 977,
    d: "M23 693h98l165 -638h-28l182 638h103l175 -639h-29l167 639h98l-202 -693h-103l-174 602h26l-181 -602h-102zM625 729l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 820,
    d: "M13 549h93l142 -518h-33l152 518h94l148 -518h-32l140 518h91l-171 -549h-95l-151 499h39l-150 -499h-96zM549 582l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 585,
    d: "M19 693h103l192 -391h-41l191 391h102l-227 -431v-262h-92v262zM432 727l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 615,
    d: "M458 -9v558h92v-558q0 -56 -17 -103t-50 -81.5t-80.5 -54t-109.5 -19.5t-113 21t-87.5 62t-57.5 102l85 31q23 -66 69 -101t103 -35q77 0 121.5 47.5t44.5 130.5zM484 260q-1 -76 -20.5 -126t-50 -78.5t-66.5 -40t-72 -11.5q-65 0 -114 28.5t-75.5 80.5t-26.5 124v312h92 v-290q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55 67t19.5 98.5zM441 582l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 585,
    d: "M19 693h103l192 -391h-41l191 391h102l-227 -431v-262h-92v262zM212 767q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM376 767q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5 t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 542,
    d: "M493 620l-338 -539h340v-81h-448v73l337 539h-334v81h443v-73zM369 928v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 456,
    d: "M412 473l-265 -397h268v-76h-374v76l266 397h-264v76h369v-76zM326 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 542,
    d: "M493 620l-338 -539h340v-81h-448v73l337 539h-334v81h443v-73zM271 751q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -15.5t15.5 -37.5t-16 -37.5t-38 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 456,
    d: "M412 473l-265 -397h268v-76h-374v76l266 397h-264v76h369v-76zM228 606q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -15.5t15.5 -37.5t-16 -37.5t-38 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 542,
    d: "M493 620l-338 -539h340v-81h-448v73l337 539h-334v81h443v-73zM410 897v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 456,
    d: "M412 473l-265 -397h268v-76h-374v76l266 397h-264v76h369v-76zM367 752v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 332,
    d: "M-48 -198l7 76h19q28 0 42.5 14.5t17.5 50.5l69 652q10 90 63 131.5t154 41.5l-7 -77q-58 0 -85 -22.5t-32 -73.5l-70 -652q-4 -50 -23.5 -81.5t-52 -45.5t-79.5 -14h-23zM24 473l7 76h278l-7 -76h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 902,
    d: "M12 0l394 693h433v-73h-282v-234h252v-72h-252v-241h282v-73h-374v623l-353 -623h-100zM149 154l39 73h320v-73h-359zM719 927v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 1124,
    d: "M300 -7q-71 0 -129.5 35.5t-93 99t-34.5 147.5t34.5 147t93 98.5t129.5 35.5q73 0 128 -34.5t79 -93.5v121h92v-549h-38q-25 0 -39.5 15t-14.5 39v68q-25 -59 -80.5 -94t-126.5 -35zM322 73q50 0 92 24t67.5 69.5t25.5 108.5q0 64 -25.5 108.5t-67.5 68.5t-92 24t-92 -24 t-67.5 -69t-25.5 -108t25.5 -108.5t67.5 -69.5t92 -24zM825 -7q-64 0 -117.5 20t-92.5 56.5t-60.5 87.5t-21.5 114q0 62 23.5 114t64.5 90.5t93.5 59.5t109.5 21q50 0 92 -13.5t72.5 -37.5t47.5 -55t17 -68q0 -42 -19 -72t-52.5 -50.5t-75.5 -31.5t-88.5 -15.5t-91.5 -3.5 q-17 0 -35.5 1t-34.5 2.5t-26 2.5q6 -39 32 -72t68.5 -52t94.5 -19q40 0 76 14t65 36t47 45l68 -50q-27 -36 -66 -64t-87 -44t-103 -16zM727 285q40 0 81.5 4.5t76 15t56 29.5t21.5 47t-17.5 49.5t-47.5 34t-68 12.5q-57 0 -103 -26.5t-72.5 -69.5t-28.5 -91q17 -2 44 -3.5 t58 -1.5zM721 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 595,
    d: "M238 -248v46q22 -2 41 6t30.5 21.5t13.5 26.5q-11 -9 -29 -9q-22 0 -38 12t-16 39q0 26 18 42t44 16q21 0 36 -11.5t23.5 -29t8.5 -36.5q0 -40 -19 -68.5t-49 -43t-64 -11.5zM305 -7q-68 0 -121.5 25.5t-86 71t-40.5 106.5l96 18q11 -66 50.5 -103t101.5 -37 q67 0 103.5 30t36.5 79q0 40 -20.5 63.5t-54 37.5t-73.5 24t-80.5 22t-74 32.5t-54 55.5t-20.5 90q0 58 29 101t81.5 67t121.5 24q63 0 111.5 -25.5t78.5 -65.5t36 -86l-93 -24q-10 55 -47.5 88t-90.5 33q-37 0 -67 -12t-48 -35.5t-18 -61.5t20.5 -61t54 -36.5t73.5 -24 t80 -23t73.5 -33.5t54 -55.5t20.5 -89.5q0 -50 -26.5 -94.5t-78.5 -72.5t-128 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 516,
    d: "M205 -248v46q22 -2 41 6t30.5 21.5t13.5 26.5q-11 -9 -29 -9q-22 0 -38 12t-16 39q0 26 18 42t44 16q21 0 36 -11.5t23.5 -29t8.5 -36.5q0 -40 -19 -68.5t-49 -43t-64 -11.5zM266 -7q-60 0 -106 20.5t-74.5 55t-38.5 76.5l86 19q10 -41 44 -67t87 -26q55 0 83.5 22.5 t28.5 56.5q0 30 -23.5 47t-60.5 28t-78.5 22t-78.5 28.5t-60 47.5t-23 80q0 43 25 77.5t70.5 55t106.5 20.5q57 0 98 -18.5t66.5 -50.5t34.5 -73l-85 -23q-9 37 -37 62t-80 25q-51 0 -78.5 -21t-27.5 -53t23 -50t59.5 -29.5t78 -22.5t78 -27.5t59.5 -46t23 -78.5 q0 -43 -24.5 -79t-69.5 -57t-106 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 542,
    d: "M208 -248v46q23 -2 41.5 6t30.5 21.5t13 26.5q-10 -9 -29 -9q-21 0 -37.5 12t-16.5 39q0 26 18.5 42t44.5 16q20 0 35 -11.5t23.5 -29t8.5 -36.5q0 -40 -18.5 -68.5t-49 -43t-64.5 -11.5zM35 693h472v-76h-190v-617h-92v617h-190v76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 390,
    d: "M113 -248v46q22 -2 41 6t30.5 21.5t13.5 26.5q-11 -9 -29 -9q-22 0 -38 12t-16 39q0 26 18 42t44 16q21 0 36 -11.5t23.5 -29t8.5 -36.5q0 -40 -19 -68.5t-49 -43t-64 -11.5zM253 -7q-57 0 -95.5 38.5t-38.5 101.5v340h-93v76h311v-76h-125v-344q0 -26 14.5 -40t34.5 -14 q15 0 27.5 5.5t23.5 14.5l45 -63q-21 -19 -47 -29t-57 -10zM75 509v40q21 0 32.5 11.5t11.5 33.5v92h93v-76q0 -14 -5.5 -27t-16.5 -22t-26 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0237",
    unicode: "\u0237",
    horizAdvX: 239,
    d: "M39 -267q-23 0 -45.5 7.5t-44.5 22.5l34 70q21 -10 40 -10q28 0 45.5 22t17.5 61v643h92v-660q0 -50 -19.5 -85t-51 -53t-68.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 311,
    d: "M294 654l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 311,
    d: "M294 752v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 320,
    d: "M159 674q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 144,
    d: "M71 678q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -15.5t15.5 -37.5t-16 -37.5t-38 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 243,
    d: "M229 712q0 -48 -31 -76t-77 -28q-43 0 -74.5 28t-31.5 76q0 49 31.5 77t74.5 28q46 0 77 -28t31 -77zM176 713q0 26 -16 41t-38 15t-37.5 -15t-15.5 -41q0 -25 15.5 -40.5t37.5 -15.5t38 15.5t16 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 241,
    d: "M186 48l24 -48l-54 -27q-34 -16 -47 -33t-13 -36q0 -23 16 -36t42 -13q30 0 65 14v-61q-16 -6 -36 -10t-40 -4q-30 0 -58.5 10t-46.5 32t-18 58q0 25 11 47.5t37 44t69 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 345,
    d: "M227 605q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 345,
    d: "M165 756l-86 -155h-62l67 155h81zM319 756l-92 -155h-61l72 155h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    horizAdvX: 0,
    d: "M17 783l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    horizAdvX: 0,
    d: "M230 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    horizAdvX: 0,
    d: "M294 597l-138 85l-139 -85v73l139 83l138 -83v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    horizAdvX: 0,
    d: "M227 605q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    horizAdvX: 0,
    d: "M17 710h353v-69h-353v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    horizAdvX: 0,
    d: "M159 602q-68 0 -105 37.5t-37 93.5v17h55q0 -36 19.5 -56t68.5 -20q48 0 68 20t20 56h55v-17q0 -56 -37 -93.5t-107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    horizAdvX: 0,
    d: "M76 705q0 22 15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5q-21 0 -36.5 15.5t-15.5 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    horizAdvX: 0,
    d: "M75 622q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM239 622q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    horizAdvX: 0,
    d: "M229 712q0 -48 -31 -76t-77 -28q-43 0 -74.5 28t-31.5 76q0 49 31.5 77t74.5 28q46 0 77 -28t31 -77zM176 713q0 26 -16 41t-38 15t-37.5 -15t-15.5 -41q0 -25 15.5 -40.5t37.5 -15.5t38 15.5t16 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    horizAdvX: 0,
    d: "M165 756l-86 -155h-62l67 155h81zM319 756l-92 -155h-61l72 155h81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    horizAdvX: 0,
    d: "M294 752v-73l-138 -82l-139 82v73l139 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M10 -272v59q22 -1 41 4.5t32 16.5t18 25q-6 -3 -12 -4t-13 -1q-26 0 -44.5 14t-18.5 45t21 50t52 19q24 0 41.5 -13.5t27.5 -34t10 -43.5q0 -47 -22 -78.5t-57.5 -46.5t-75.5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0327",
    unicode: "\u0327",
    horizAdvX: 0,
    d: "M126 -57q38 0 67.5 -11t45.5 -33t16 -55q0 -32 -15.5 -55.5t-43 -36t-63.5 -12.5h-116v60h98q32 0 48 10t16 34q0 23 -16 32.5t-48 9.5h-51v121h62v-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    horizAdvX: 0,
    d: "M186 48l24 -48l-54 -27q-34 -16 -47 -33t-13 -36q0 -23 16 -36t42 -13q30 0 65 14v-61q-16 -6 -36 -10t-40 -4q-30 0 -58.5 10t-46.5 32t-18 58q0 25 11 47.5t37 44t69 40.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 710,
    d: "M39 549h628v-73h-79v-476h-92v476h-286v-476h-92v476h-79v73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 977,
    d: "M23 693h98l165 -638h-28l182 638h103l175 -639h-29l167 639h98l-202 -693h-103l-174 602h26l-181 -602h-102zM328 933l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 820,
    d: "M13 549h93l142 -518h-33l152 518h94l148 -518h-32l140 518h91l-171 -549h-95l-151 499h39l-150 -499h-96zM243 783l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 977,
    d: "M23 693h98l165 -638h-28l182 638h103l175 -639h-29l167 639h98l-202 -693h-103l-174 602h26l-181 -602h-102zM655 937v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 820,
    d: "M13 549h93l142 -518h-33l152 518h94l148 -518h-32l140 518h91l-171 -549h-95l-151 499h39l-150 -499h-96zM579 783v-80l-213 -114v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 977,
    d: "M23 693h98l165 -638h-28l182 638h103l175 -639h-29l167 639h98l-202 -693h-103l-174 602h26l-181 -602h-102zM403 773q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM567 773q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5 t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 820,
    d: "M13 549h93l142 -518h-33l152 518h94l148 -518h-32l140 518h91l-171 -549h-95l-151 499h39l-150 -499h-96zM329 622q-21 0 -36.5 15.5t-15.5 37.5t15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5zM493 622q-22 0 -37.5 15.5t-15.5 37.5t15.5 37.5 t37.5 15.5t37 -16t15 -38q0 -21 -15 -36.5t-37 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 682,
    d: "M60 561q0 59 25.5 106.5t77.5 75.5t133 28q72 0 120.5 -23.5t73.5 -61.5t25 -81q0 -37 -14 -64.5t-35.5 -48.5t-42.5 -38t-35 -33t-14 -33q0 -14 9.5 -25.5t33.5 -23.5t68 -27q75 -24 107.5 -63.5t32.5 -97.5q0 -47 -23 -83.5t-65.5 -57t-102.5 -20.5q-87 0 -142 47.5 t-63 132.5h94q2 -48 31 -77t80 -29q46 0 71 21t25 59q0 36 -21.5 58t-76.5 40q-79 26 -115 56t-36 77q0 31 14.5 54.5t35.5 43t42 38.5t35.5 40t14.5 47q0 45 -34.5 70.5t-94.5 25.5q-76 0 -109 -38.5t-33 -105.5v-550h-92v561z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBC",
    unicode: "\u1EBC",
    horizAdvX: 514,
    d: "M452 617h-282v-229h252v-76h-252v-236h282v-76h-374v693h374v-76zM328 750q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBD",
    unicode: "\u1EBD",
    horizAdvX: 623,
    d: "M334 -7q-64 0 -117.5 20t-92.5 56.5t-60 87.5t-21 114q0 62 23.5 114t64 90.5t93 59.5t109.5 21q51 0 93 -13.5t72.5 -37.5t47 -55t16.5 -68q0 -52 -29 -86.5t-77 -54t-105.5 -27t-115.5 -5.5q-16 0 -35 1t-35 2.5t-25 2.5q6 -39 32 -72t68 -52t94 -19q40 0 76.5 14 t65 36t46.5 45l68 -50q-26 -36 -65 -64t-87 -44t-104 -16zM237 285q40 0 81 4.5t76 15t56.5 29.5t21.5 47t-17.5 49.5t-48 34t-68.5 12.5q-57 0 -102.5 -26.5t-72 -69.5t-29.5 -91q18 -2 44.5 -3.5t58.5 -1.5zM380 605q-26 0 -44 11.5t-33.5 23t-36.5 11.5 q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 585,
    d: "M19 693h103l192 -391h-41l191 391h102l-227 -431v-262h-92v262zM178 928l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 615,
    d: "M458 -9v558h92v-558q0 -56 -17 -103t-50 -81.5t-80.5 -54t-109.5 -19.5t-113 21t-87.5 62t-57.5 102l85 31q23 -66 69 -101t103 -35q77 0 121.5 47.5t44.5 130.5zM484 260q-1 -76 -20.5 -126t-50 -78.5t-66.5 -40t-72 -11.5q-65 0 -114 28.5t-75.5 80.5t-26.5 124v312h92 v-290q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55 67t19.5 98.5zM187 783l213 -125v-69l-213 114v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF8",
    unicode: "\u1EF8",
    horizAdvX: 585,
    d: "M19 693h103l192 -391h-41l191 391h102l-227 -431v-262h-92v262zM356 750q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF9",
    unicode: "\u1EF9",
    horizAdvX: 615,
    d: "M458 -9v558h92v-558q0 -56 -17 -103t-50 -81.5t-80.5 -54t-109.5 -19.5t-113 21t-87.5 62t-57.5 102l85 31q23 -66 69 -101t103 -35q77 0 121.5 47.5t44.5 130.5zM484 260q-1 -76 -20.5 -126t-50 -78.5t-66.5 -40t-72 -11.5q-65 0 -114 28.5t-75.5 80.5t-26.5 124v312h92 v-290q0 -84 42.5 -129.5t109.5 -45.5q45 0 80.5 24.5t55 67t19.5 98.5zM365 605q-26 0 -44 11.5t-33.5 23t-36.5 11.5q-16 0 -27.5 -10.5t-14.5 -33.5h-54q7 53 34.5 79t66.5 26q26 0 44 -11t33.5 -22.5t36.5 -11.5q17 0 28.5 10.5t14.5 32.5h53q-6 -51 -33.5 -78t-67.5 -27 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 679,
    d: "M76 405h527v-77h-527v77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 887,
    d: "M76 405h735v-77h-735v77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 209,
    d: "M176 693v-46q-42 0 -67 -16t-31 -43q6 6 15.5 9t17.5 3q26 0 44 -13.5t18 -44.5q0 -30 -20.5 -48.5t-50.5 -18.5q-23 0 -40.5 13t-27 33.5t-9.5 41.5q0 46 20.5 74.5t55 42t75.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 209,
    d: "M32 482v45q43 0 67.5 16.5t30.5 43.5q-7 -6 -16 -9t-18 -3q-25 0 -43.5 13.5t-18.5 44.5q0 30 20.5 48.5t51.5 18.5q23 0 40 -13t27 -33.5t10 -42.5q0 -44 -20.5 -73t-54.5 -42.5t-76 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 196,
    d: "M9 -105v48q44 1 71 17.5t33 44.5q-7 -5 -16.5 -8.5t-19.5 -3.5q-26 0 -45.5 14.5t-19.5 46.5t22 51t53 19q25 0 43 -13.5t28.5 -34.5t10.5 -45q0 -47 -22 -77t-58 -44.5t-80 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 378,
    d: "M176 693v-46q-42 0 -67 -16t-31 -43q15 12 35 12q16 0 30 -6.5t22 -19t8 -32.5q0 -30 -20.5 -48.5t-50.5 -18.5q-23 0 -40.5 13t-27 33.5t-9.5 41.5q0 46 20.5 74.5t55 42t75.5 13.5zM344 693v-46q-41 0 -66 -16t-32 -43q15 12 36 12q16 0 29.5 -6.5t22 -19t8.5 -32.5 q0 -30 -20.5 -48.5t-50.5 -18.5q-23 0 -40.5 13t-27.5 33.5t-10 41.5q0 46 20.5 74.5t55 42t75.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 377,
    d: "M32 482v45q43 0 67.5 16.5t30.5 43.5q-7 -6 -16 -9t-18 -3q-25 0 -43.5 13.5t-18.5 44.5q0 30 20.5 48.5t51.5 18.5q23 0 40 -13t27 -33.5t10 -42.5q0 -44 -20.5 -73t-54.5 -42.5t-76 -13.5zM200 482v45q44 0 68.5 16.5t29.5 43.5q-6 -6 -15 -9t-18 -3q-26 0 -44 13.5 t-18 44.5q0 30 20.5 48.5t50.5 18.5q23 0 40.5 -13t27 -33.5t9.5 -42.5q0 -44 -20.5 -73t-54.5 -42.5t-76 -13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 372,
    d: "M9 -105v48q44 1 71 17.5t33 44.5q-7 -5 -16.5 -8.5t-19.5 -3.5q-26 0 -45.5 14.5t-19.5 46.5t22 51t53 19q25 0 43 -13.5t28.5 -34.5t10.5 -45q0 -47 -22 -77t-58 -44.5t-80 -14.5zM186 -105v48q44 1 70.5 17.5t33.5 44.5q-8 -5 -17.5 -8.5t-18.5 -3.5q-27 0 -46 14.5 t-19 46.5t22 51t53 19q24 0 42 -13.5t28.5 -34.5t10.5 -45q0 -47 -22 -77t-58 -44.5t-79 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 548,
    d: "M503 549v-73l-193 8l10 -744h-92l10 744l-193 -8v73l193 -9l-10 241h92l-10 -241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 549,
    d: "M504 476l-193 8v-446l193 8v-73l-193 9l9 -242h-92l10 242l-192 -9v73l192 -8v446l-192 -8v73l192 -9l-10 241h92l-9 -241l193 9v-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 414,
    d: "M206 211q-33 0 -61.5 16t-44.5 44t-16 62q0 35 16 62.5t44.5 44.5t61.5 17q35 0 63 -16.5t44.5 -44.5t16.5 -63q0 -34 -16.5 -61.5t-44.5 -44t-63 -16.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 601,
    d: "M304 -7q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5zM493 -7q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5zM116 -7 q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1008,
    d: "M91 0l404 693h91l-405 -693h-90zM491 -7q-63 0 -104.5 40t-41.5 108q0 69 41.5 108.5t104.5 39.5q62 0 103.5 -39.5t41.5 -108.5q0 -68 -41.5 -108t-103.5 -40zM490 51q34 0 53.5 22.5t19.5 67.5q0 46 -19.5 68.5t-53.5 22.5q-32 0 -52.5 -22.5t-20.5 -68.5 q0 -45 20.5 -67.5t52.5 -22.5zM187 404q-63 0 -104.5 40t-41.5 109q0 68 41.5 107.5t104.5 39.5t104.5 -39.5t41.5 -107.5q0 -69 -41.5 -109t-104.5 -40zM187 461q34 0 53.5 23.5t19.5 68.5t-19.5 67.5t-53.5 22.5q-33 0 -53 -22.5t-20 -67.5t20 -68.5t53 -23.5zM821 -7 q-62 0 -104 40t-42 108q0 69 42 108.5t104 39.5q63 0 104.5 -39.5t41.5 -108.5q0 -68 -41.5 -108t-104.5 -40zM821 51q33 0 53 22.5t20 67.5q0 46 -20 68.5t-53 22.5t-53 -22.5t-20 -68.5q0 -45 20 -67.5t53 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 281,
    d: "M231 120h-90l-96 175l96 175h90l-99 -175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 281,
    d: "M50 120l99 175l-99 175h90l96 -175l-96 -175h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 498,
    d: "M416 693h92l-405 -693h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A8",
    unicode: "\u20A8",
    horizAdvX: 1112,
    d: "M78 0v693h225q81 0 135 -27.5t80.5 -73t26.5 -102.5q0 -72 -44.5 -120t-114.5 -63q54 -17 97 -58t71 -103t37 -146h-98q-7 85 -39 144.5t-91 92.5q-37 21 -85.5 31t-107.5 10v-278h-92zM170 355h133q74 0 110.5 38.5t36.5 94.5q0 59 -36 94t-111 35h-133v-262zM829 -7 q-60 0 -105.5 20.5t-74.5 55t-39 76.5l87 19q10 -41 44 -67t87 -26q54 0 82.5 22.5t28.5 56.5q0 30 -23 47t-60 28t-78.5 22t-78.5 28.5t-60.5 47.5t-23.5 80q0 43 25 77.5t70.5 55t106.5 20.5q58 0 99 -18.5t66.5 -50.5t34.5 -73l-85 -23q-10 37 -37.5 62t-80.5 25 q-50 0 -78 -21t-28 -53t23.5 -50t60 -29.5t77.5 -22.5t77.5 -27.5t60 -46t23.5 -78.5q0 -43 -25 -79t-70 -57t-106 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 803,
    d: "M25 397v64h429v-64h-429zM25 232v64h429v-64h-429zM455 700q75 0 135.5 -24t104 -69t68.5 -108l-82 -31q-28 69 -86 109.5t-139 40.5q-73 0 -131 -33t-91.5 -94t-33.5 -144t33 -144t90.5 -94t130.5 -33q51 0 95 17t78.5 49t52.5 76l87 -29q-24 -59 -69 -103t-106.5 -68.5 t-137.5 -24.5q-74 0 -137 26t-110.5 73t-74.5 111.5t-27 143.5q0 78 27 143t75 111.5t111.5 72.5t136.5 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 634,
    d: "M467 654v-148q0 -82 -25.5 -132.5t-87 -74t-172.5 -23.5v-79q0 -59 26 -96.5t92 -37.5q61 0 88 34.5t27 94.5h85q-1 -101 -53.5 -151.5t-148.5 -50.5q-100 0 -151 56t-51 154v140q97 0 154 7t84.5 24t36.5 49.5t9 84.5v149h87zM51 698h544v-68h-544v68zM51 457v67h544 v-67h-544z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BA",
    unicode: "\u20BA",
    horizAdvX: 831,
    d: "M358 -17q-39 0 -82 5.5t-90 16.5v697h95v-626q20 -4 39.5 -5.5t37.5 -1.5q73 0 124.5 23t83.5 68t47 109.5t15 147.5h95q0 -144 -37.5 -240.5t-118 -145t-209.5 -48.5zM27 206v66l427 103v-66zM24 371v64l434 107v-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BD",
    unicode: "\u20BD",
    horizAdvX: 624,
    d: "M35 359h313q78 0 112.5 36t34.5 94q0 61 -34.5 96t-112.5 35h-134v-620h-92v693h226q82 0 135.5 -27.5t79.5 -73.5t26 -103q0 -53 -24.5 -99.5t-77 -75t-139.5 -28.5h-313v73zM35 195h396v-74h-396v74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 281,
    d: "M78 111v629h92v-621q0 -23 13 -34.5t31 -11.5q11 0 21 4l20 -69q-25 -15 -60 -15q-28 0 -55 12t-44.5 38t-17.5 68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 783,
    d: "M26 693h241v-57h-85v-295h-71v295h-85v57zM324 693h93l122 -300h-28l127 300h89v-352h-69v297l21 6l-130 -303h-51l-127 303l19 -6v-297h-66v352z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2126",
    unicode: "\u2126",
    horizAdvX: 787,
    d: "M53 0v73h193l-19 -20q-61 24 -102 69t-62.5 103.5t-21.5 124.5q0 78 27.5 143.5t75.5 113t112 73.5t137 26q74 0 138 -26t112.5 -73.5t76 -113t27.5 -143.5q0 -66 -21.5 -124.5t-62.5 -103.5t-103 -69l-19 20h192v-73h-274v76q57 15 100.5 51t68.5 91.5t25 126.5 q0 85 -34 147.5t-93 96t-133 33.5t-133 -34.5t-92.5 -96.5t-33.5 -146q1 -71 26 -126.5t69 -91.5t99 -51v-76h-275z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 761,
    d: "M389 -7q-97 0 -175 39.5t-122.5 115t-44.5 183.5q0 103 38.5 187t113 133.5t181.5 49.5q81 0 143 -27t105 -73t64.5 -104t21.5 -121v-61h-532v-167q39 -46 88 -70t119 -24q76 0 136 34t120 93l41 -44q-62 -67 -136 -105.5t-161 -38.5zM182 379h388v177q-32 40 -80.5 62 t-109.5 22t-112 -23t-86 -72v-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 572,
    d: "M235 -8q-53 0 -98 25t-71.5 76.5t-26.5 131.5q0 66 20.5 126t56.5 106t85 73t108 27q54 0 86 -26t49 -73l-6 -3q0 61 -14.5 113.5t-48 84.5t-90.5 32q-18 0 -37.5 -3.5t-42.5 -9.5v54q25 8 48 11t45 3q75 0 127.5 -39t80 -112.5t27.5 -176.5q0 -97 -23 -175t-64 -132.5 t-95 -83.5t-116 -29zM245 70q54 0 95 35.5t64.5 93.5t23.5 126q0 77 -31.5 115.5t-84.5 38.5q-51 0 -92 -33.5t-64 -91t-23 -129.5q0 -80 32 -117.5t80 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2206",
    unicode: "\u2206",
    horizAdvX: 681,
    d: "M302 693h77l282 -621v-72h-641v72zM340 588l-226 -516h453z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 739,
    d: "M39 698h661v-72h-79v-626h-92v626h-319v-626h-92v626h-79v72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 458,
    d: "M40 693h390v-72h-327l-6 22l287 -289v-72l-287 -293l-4 20h337v-71h-390v106l260 272l-260 271v106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 625,
    d: "M112 405h400v-77h-400v77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 790,
    d: "M709 869h67l-492 -912h-46l-125 220l-65 -38l-28 48l143 84l129 -227l-23 9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 697,
    d: "M183 199q-64 1 -107 39.5t-43 108.5q0 47 20.5 80.5t56 51.5t77.5 18q41 0 72 -17t56.5 -43t47 -55.5t43 -56t45.5 -43t54 -16.5q37 0 59.5 22t22.5 60q0 39 -22 60t-59 21q-43 0 -80 -33t-54 -83l-44 32q11 39 36.5 73.5t63.5 56.5t86 22q42 0 76 -18t54 -51t20 -80 t-21 -80.5t-56 -51t-77 -17.5q-41 0 -73.5 16.5t-58.5 43t-48.5 56t-43.5 55.5t-44 43t-50 17q-37 0 -59.5 -22t-22.5 -61q0 -38 22 -59.5t59 -21.5q43 0 80 33t54 83l44 -32q-11 -38 -36.5 -73t-63 -56.5t-86.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 262,
    d: "M135 779q5 50 24 81t51 44.5t76 13.5h23l-8 -77h-18q-25 0 -38.5 -13.5t-17.5 -48.5l-92 -836q-5 -50 -23.5 -81.5t-50 -45.5t-77.5 -14h-23l8 76h19q26 0 38.5 15t16.5 50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 625,
    d: "M394 199q-28 0 -50 10t-40.5 23t-37 23t-40.5 10q-26 0 -44.5 -17t-23.5 -47h-68q13 76 50 111.5t92 35.5q29 0 51 -10t41 -23t37.5 -23t39.5 -10q26 0 44.5 17t22.5 47h68q-12 -75 -49 -111t-93 -36zM394 410q-28 0 -50 10t-40.5 23t-37 23t-40.5 10q-26 0 -44.5 -17 t-23.5 -47h-68q13 76 50 111.5t92 35.5q29 0 51 -10t41 -23t37.5 -23t39.5 -10q26 0 44.5 17t22.5 47h68q-12 -75 -49 -111t-93 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 625,
    d: "M504 610h70l-418 -489h-70zM51 297h521v-77h-521v77zM51 513h521v-78h-521v78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 625,
    d: "M137 155h355v-70h-355v70zM494 212h-121l-241 191l241 192h121l-250 -200v18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 625,
    d: "M132 212l249 201v-18l-249 200h120l242 -192l-242 -191h-120zM488 155v-70h-355v70h355z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 554,
    d: "M278 592l241 -242l-242 -242l-241 242zM278 493l-142 -143l141 -143l143 143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25CC",
    unicode: "\u25CC",
    horizAdvX: 600,
    d: "M490 367q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5t12 -30.5t-12 -30.5t-31 -11.5zM114 81q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5t12 -30.5t-12 -30.5t-31 -11.5zM212 5q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5t12 -30.5t-12 -30.5 t-31 -11.5zM69 194q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5t12 -30.5t-12 -30.5t-31 -11.5zM336 -9q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5t12 -30.5t-12 -30.5t-31 -11.5zM84 315q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5t12 -30.5 t-12 -30.5t-31 -11.5zM451 37q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5t12 -30.5t-12 -30.5t-31 -11.5zM160 414q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5t12 -30.5t-12 -30.5t-31 -11.5zM524 133q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5 t12 -30.5t-12 -30.5t-31 -11.5zM277 456q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5t12 -30.5t-12 -30.5t-31 -11.5zM534 253q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5t31 -11.5t12 -30.5t-12 -30.5t-31 -11.5zM398 441q-19 0 -31 11.5t-12 30.5t12 30.5t31 11.5 t31 -11.5t12 -30.5t-12 -30.5t-31 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i.loclTRK",
    horizAdvX: 247,
    d: "M78 549h92v-549h-92v549zM71 705q0 22 15.5 37.5t37.5 15.5t37.5 -16t15.5 -38q0 -21 -16 -36.5t-38 -15.5q-21 0 -36.5 15.5t-15.5 37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT",
    horizAdvX: 221,
    d: "M112 275q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT.case",
    horizAdvX: 196,
    d: "M99 288q-30 0 -50.5 19.5t-20.5 46.5q0 28 20.5 46.5t50.5 18.5q29 0 49.5 -18.5t20.5 -46.5q0 -27 -20.5 -46.5t-49.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C.alt",
    horizAdvX: 0,
    d: "M264 504v46q23 -2 41.5 6t30.5 21.5t13 26.5q-10 -9 -29 -9q-21 0 -37.5 12t-16.5 39q0 26 18.5 42t44.5 16q20 0 35 -11.5t23.5 -29t8.5 -36.5q0 -40 -18.5 -68.5t-49 -43t-64.5 -11.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: "\xBF",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\u2026",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\u2026",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: ".",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "j",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u1EBD",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0153",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0151",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u014F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u014D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u011B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0119",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0117",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0115",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0113",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0111",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u010F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u010D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u010B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0107",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xEB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xEA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xE9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xE8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xE7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "o",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "i",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "e",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "c",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u2026",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0152",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0150",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u014E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u014C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0122",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0120",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u011E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u010C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u010A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0106",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0104",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0102",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0100",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xD2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC3",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC2",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC1",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC0",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "Q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "O",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "G",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "6",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "1",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "2",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1EF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1EF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0178",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0176",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "Y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1EF9",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1EF3",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u1EBD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u021A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0177",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0164",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0162",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0153",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0151",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u014F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u014D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0142",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u013E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u013C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u013A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u011B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0119",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0117",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0115",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0113",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0111",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u010F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u010D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u010B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0107",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xFF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xFD",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xEA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xE8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "j",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "T",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "F",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "2",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "1",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "P",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01FD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0153",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0151",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0123",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0121",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0119",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0117",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0115",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0113",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0111",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0107",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0105",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0104",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0103",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0102",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0101",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0100",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "g",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "J",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u2026",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ":",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "1",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ",",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\u2026",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "2",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: ".",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: ",",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2026",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "9",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "2",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "1",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: ".",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: ",",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u021A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u0164",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u0162",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "T",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2026",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ".",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ",",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ")",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "1",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2026",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "7",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0104",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0102",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0100",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ")",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2026",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ".",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ")",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u2026",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ".",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ">",
    u2: "2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u1EF9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u1EF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0177",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xFF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\xFD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "P",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xDE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "L",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "*",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "!",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "J",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0142",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u013E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u013C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u013A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "i",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBD",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0219",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FC",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0161",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0159",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0157",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0155",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0152",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0150",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0148",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0146",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0144",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0123",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0122",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0121",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0120",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0111",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0106",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "q",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "H",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u2026",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: ".",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u2212",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u2014",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u2013",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u1EF8",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u1EF2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u021A",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u0178",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u0176",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u0164",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\u0162",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "\xDD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "Y",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "V",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "T",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "D",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "H",
    u2: "-",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u021B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0165",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0163",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u1EBD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0153",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0151",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u014F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u014D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0142",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u013E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u013C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u013A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u011B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0119",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0117",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0115",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0113",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0111",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u010F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u010D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u010B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\u0107",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xF6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xF5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xF4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xEA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xE8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "\xE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: "I",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "I",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u2026",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: ",",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: ",",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    g2: "periodcentered.loclCAT.case",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: ",",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EBD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FC",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0151",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0119",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0117",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0115",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0113",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0111",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0107",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0105",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0103",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0101",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EF9",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EF3",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EBD",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1E85",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1E83",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1E81",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u01FD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u01FC",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u017E",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u017C",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u017A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0177",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0175",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0173",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0171",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u016F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u016D",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u016B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0169",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0153",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0152",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0151",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0150",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u014F",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u014E",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u014D",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u014C",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0137",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0123",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0122",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0121",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0120",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u011F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u011E",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u011B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0119",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0117",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0115",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0113",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0111",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u010F",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u010D",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u010C",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u010B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u010A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0107",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0106",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0105",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0104",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0103",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0102",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0101",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0100",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xFF",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xFD",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xFC",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xFB",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xFA",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xF9",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xF6",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xF5",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xF4",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xF3",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xF2",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xF0",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xEB",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xEA",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xE9",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xE8",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xE7",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xE6",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xE5",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xE4",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xE3",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xE2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xE1",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xE0",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD6",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD5",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD4",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD3",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD2",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC7",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC6",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC5",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC4",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC3",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC2",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC1",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC0",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "z",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "y",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "w",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "u",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "q",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "o",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "k",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "h",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "g",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "e",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "d",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "c",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "b",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "a",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "X",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Q",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "O",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "H",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "G",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "C",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "/",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ",",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xEE",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xED",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "H",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ";",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ":",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "I",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0152",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0150",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0122",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0120",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0106",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xC7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2212",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2014",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2013",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1EBD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u021B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0173",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0171",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u016F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u016D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u016B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0169",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0165",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0163",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0153",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0151",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0123",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0121",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0119",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0117",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0115",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0113",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0111",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0107",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "o",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "g",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "e",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "d",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "c",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "-",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "j",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "j",
    k: -80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u2212",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u2014",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u2013",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "v",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "-",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2212",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2026",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2019",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2014",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2013",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u1E85",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u1E83",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u1E81",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0175",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0173",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0171",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u016F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u016D",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u016B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0169",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0137",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0127",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xFC",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xFB",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xFA",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF9",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "x",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "w",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "u",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "k",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "h",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "b",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "?",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ".",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "-",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ")",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: ",",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u2212",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u2014",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u2013",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "-",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: ")",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u2212",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u2014",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u2013",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "-",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u2026",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0159",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0157",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0155",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0148",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0146",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0144",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0131",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\xF1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "r",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "n",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "m",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: ".",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: ")",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u2212",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u2026",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u2014",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u2013",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: ".",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "-",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: ",",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1EBD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1E85",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1E83",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u1E81",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u021B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0175",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0165",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0163",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0151",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u014F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u014D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u011B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0119",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0117",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0115",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0113",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0111",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u010F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u010D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u010B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0107",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xEB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xEA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "x",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "w",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "t",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "f",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "p",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: ",",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: ",",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: ",",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "f",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: ",",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2026",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0104",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0102",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0100",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "f",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "@",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: ",",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u1EBD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0151",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u014F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u014D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u011B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0119",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0117",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0115",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0113",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0111",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0107",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: ",",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\u017E",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\u017C",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\u017A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "z",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "j",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "j",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    u2: "6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "P",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xDE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "L",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "*",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "!",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "P",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xDE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "L",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "*",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "!",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "P",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xDE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "L",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "*",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "!",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "P",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xDE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "L",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "*",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "!",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "P",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xDE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "L",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "*",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "!",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "P",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xDE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "L",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "*",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "!",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ":",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u1EF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u1EF2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0178",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0176",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xDD",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "Y",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: ",",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ",",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "P",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xDE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "L",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "*",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "!",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "P",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xDE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "L",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "*",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "!",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "P",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2019",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xDE",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "L",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "F",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "*",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "!",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "q",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "H",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "q",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "H",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "q",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "H",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: ",",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: ",",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    g2: "periodcentered.loclCAT.case",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: ",",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013A",
    u2: "p",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013A",
    u2: ",",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    g2: "periodcentered.loclCAT.case",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: ",",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "p",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: ",",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    g2: "periodcentered.loclCAT.case",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: ",",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "p",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: ",",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    g2: "periodcentered.loclCAT.case",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u201D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u2019",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: ",",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: ",",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: ",",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: ",",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "*",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: ")",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "!",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "f",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "f",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "v",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "f",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: ",",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u012B",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xEE",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xED",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "J",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: ",",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: ",",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u012B",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xEE",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xED",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "J",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: ",",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "J",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "I",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "f",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "@",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "p",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ":",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0177",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0177",
    u2: ",",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "p",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ":",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "i",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: ",",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\u012B",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xEF",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xEE",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xED",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "J",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: ",",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "J",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "I",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "f",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "@",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "J",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "I",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "f",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "@",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "J",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "q",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "I",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "x",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "f",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "@",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "p",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ":",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF3",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF3",
    u2: ",",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u2019",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "q",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "p",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "H",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: ";",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: ":",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: ",",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF9",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF9",
    u2: ",",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u1EBD",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0153",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0151",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u014F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u014D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u011B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0119",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0117",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0115",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0113",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0111",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0107",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xEA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "o",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "e",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "c",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u01FD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0152",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0150",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u014E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u014C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0122",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0120",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u011E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u010A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0106",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0105",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0104",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0103",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0102",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0101",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0100",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC3",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC2",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC1",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC0",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "f",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0104",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0102",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0100",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC5",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u1EBD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u01FD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0153",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0152",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0151",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0150",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u014F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u014E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u014D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u014C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0122",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0120",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u011E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u011B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0119",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0117",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0115",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0113",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0111",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u010A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0107",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0106",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0105",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0103",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0101",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xEA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "o",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "e",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "d",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "c",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "f",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "2",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "1",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "v",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "P",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "i",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2248",
    u2: "1",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u1EBD",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u0153",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u0151",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u014F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u014D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u011B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u0119",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u0117",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u0115",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u0113",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u0111",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u010F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u010D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u010B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\u0107",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xF6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xF5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xF4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xF3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xF2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xEB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xEA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xE9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xE8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "\xE7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "o",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "e",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "d",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fi",
    u2: "c",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni1EBD",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "T,uni0162,Tcaron,uni021A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "AE,AEacute",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut",
    g2: "period,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,thorn,omacron,obreve,ohungarumlaut",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,thorn,omacron,obreve,ohungarumlaut",
    g2: "m,n,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,thorn,omacron,obreve,ohungarumlaut",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,thorn,omacron,obreve,ohungarumlaut",
    g2: "T,uni0162,Tcaron,uni021A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,thorn,omacron,obreve,ohungarumlaut",
    g2: "hyphen,endash,emdash,minus",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,thorn,omacron,obreve,ohungarumlaut",
    g2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "AE,AEacute",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "period,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "l,lacute,uni013C,lcaron,lslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "T,uni0162,Tcaron,uni021A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "hyphen,endash,emdash,minus",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "t,uni0163,tcaron,uni021B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    g2: "V",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "hyphen,endash,emdash,minus",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,nacute,uni0146,ncaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,nacute,uni0146,ncaron",
    g2: "hyphen,endash,emdash,minus",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,nacute,uni0146,ncaron",
    g2: "period,ellipsis",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "m,n,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "T,uni0162,Tcaron,uni021A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "hyphen,endash,emdash,minus",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "AE,AEacute",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    g2: "period,ellipsis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "m,n,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    g2: "T,uni0162,Tcaron,uni021A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "l,lacute,uni013C,lcaron,lslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "b,h,k,uni0137",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "period,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "T,uni0162,Tcaron,uni021A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "hyphen,endash,emdash,minus",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "l,lacute,uni013C,lcaron,lslash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "b,h,k,uni0137",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "t,uni0163,tcaron,uni021B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,endash,emdash,minus",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "period,ellipsis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "hyphen,endash,emdash,minus",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "t,uni0163,tcaron,uni021B",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "hyphen,endash,emdash,minus",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "t,uni0163,tcaron,uni021B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "period,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "m,n,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "b,h,k,uni0137",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "l,lacute,uni013C,lcaron,lslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "T,uni0162,Tcaron,uni021A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "t,uni0163,tcaron,uni021B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "m,n,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "T,uni0162,Tcaron,uni021A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "AE,AEacute",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,uni021A",
    g2: "period,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,minus",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,minus",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,minus",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,minus",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,minus",
    g2: "T,uni0162,Tcaron,uni021A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,minus",
    g2: "b,h,k,uni0137",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,minus",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,minus",
    g2: "V",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "hyphen,endash,emdash,minus",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,uni013C,lcaron",
    g2: "l,lacute,uni013C,lcaron,lslash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,uni013C,lcaron",
    g2: "t,uni0163,tcaron,uni021B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,uni013C,lcaron",
    g2: "period,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "hyphen,endash,emdash,minus",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "t,uni0163,tcaron,uni021B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "period,ellipsis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,uni021B",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,uni021B",
    g2: "t,uni0163,tcaron,uni021B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "AE,AEacute",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,uni1EF9",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,uni0136",
    g2: "period,ellipsis",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "period,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF8",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "period,ellipsis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "period,ellipsis",
    g2: "l,lacute,uni013C,lcaron,lslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "period,ellipsis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "period,ellipsis",
    g2: "T,uni0162,Tcaron,uni021A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "period,ellipsis",
    g2: "t,uni0163,tcaron,uni021B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "period,ellipsis",
    g2: "V",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni1EBD",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aeacute",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,r,ntilde,dotlessi,nacute,uni0146,ncaron,racute,uni0157,rcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,endash,emdash,minus",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "period,ellipsis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "period,ellipsis",
    k: 40
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.28c379c5dc2588599e8fbc474a93acca.svg";
export { ForwardRef as ReactComponent };